import React from 'react'
import PropTypes from 'prop-types'

const Icons = ({icon, height, width, color, onClick}) => {
  switch (icon) {
    case 'EMAIL':
      return (
        <svg viewBox="0 0 18 14" width={18} height={14}>
          <defs>
            <polygon
              id="a"
              points="0.0025837 0 18.003 0 18.003 18 0.0025837 18"
            />
          </defs>
          <g fill="none" fillRule="evenOdd">
            <g transform="translate(-1386 -552)">
              <g transform="translate(1360 86)">
                <g transform="translate(0 408)">
                  <g transform="translate(26 27)">
                    <g transform="translate(0 29)">
                      <mask id="b" fill="white">
                        <use xlinkHref="#a" />
                      </mask>
                      <path
                        d="m17.638 13.024c0 0.38657-0.10886 0.74502-0.28331 1.0604l-5.569-6.2311 5.5088-4.8198c0.21432 0.34011 0.34351 0.73964 0.34351 1.1712v8.8192zm-8.8192-4.0393l7.6651-6.7069c-0.3144-0.17225-0.66867-0.27771-1.0508-0.27771h-13.229c-0.38269 0-0.73692 0.10546-1.0502 0.27771l7.6646 6.7069zm2.137-0.4059l-1.7741 1.5536c-0.104 0.090301-0.23318 0.13556-0.36284 0.13556-0.1297 0-0.25889-0.045258-0.36284-0.13573l-1.7746-1.5535-5.6396 6.3108c0.33812 0.21212 0.73425 0.33911 1.1627 0.33911h13.229c0.42864 0 0.82477-0.12699 1.1627-0.33911l-5.6399-6.3108zm-10.613-5.5452c-0.21432 0.34011-0.34351 0.73964-0.34351 1.1712v8.8192c0 0.38657 0.10817 0.74502 0.28309 1.0604l5.5685-6.2323-5.5081-4.8186z"
                        fill="#A4A9B7"
                        mask="url(#b)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'PHONE':
      return (
        <svg viewBox="0 0 14 15" width={14} height={15}>
          <defs>
            <polygon id="a" points="0 0 18 0 18 18 0 18" />
          </defs>
          <g fill="none" fillRule="evenOdd">
            <g transform="translate(-1387 -522)">
              <g transform="translate(1360 86)">
                <g transform="translate(0 408)">
                  <g transform="translate(26 27)">
                    <mask id="b" fill="white">
                      <use xlinkHref="#a" />
                    </mask>
                    <path
                      d="m14.686 12.864l-2.1617-2.1626c-0.43092-0.42876-1.1435-0.41547-1.5889 0.030294l-1.0894 1.0891c-0.068626-0.037404-0.14003-0.077282-0.21484-0.11932-0.68842-0.38177-1.6291-0.90327-2.6205-1.8946-0.99353-0.99384-1.5166-1.937-1.898-2.6254-0.041114-0.072336-0.079755-0.1422-0.11716-0.2099l0.73047-0.72954 0.35982-0.35982c0.44576-0.44669 0.45905-1.1592 0.029058-1.5889l-2.1626-2.1626c-0.42876-0.42999-1.1422-0.4167-1.5892 0.029985l-0.60836 0.61238 0.015456 0.016693c-0.20402 0.2609-0.37435 0.56168-0.50109 0.88534-0.11716 0.30913-0.19073 0.60372-0.22319 0.89832-0.28625 2.3667 0.79569 4.5293 3.7299 7.4648 4.0573 4.056 7.3272 3.7506 7.4685 3.7349 0.30665-0.036168 0.60125-0.10974 0.90079-0.22566 0.32118-0.12551 0.62196-0.29583 0.88163-0.49986l0.013292 0.012056 0.61825-0.60496c0.44421-0.447 0.45751-1.1592 0.027821-1.5905z"
                      fill="#A4A9B7"
                      mask="url(#b)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case 'LOCATION':
      return (
        <svg viewBox="0 0 12 17" width={12} height={17}>
          <g fill="none" fillRule="evenOdd">
            <g transform="translate(-1389 -627)" fill={color || '#52555B'}>
              <g transform="translate(1360 86)">
                <g transform="translate(29 529)">
                  <path d="m11.361 16.204c-0.060525-0.22545-0.18251-0.46567-0.27307-0.67634-1.0805-2.597-3.442-3.5281-5.349-3.5281-2.5522 0-5.3635 1.7118-5.7394 5.2399v0.72021c0 0.030263 0.010088 0.30052 0.024632 0.43611 0.2109 1.6806 1.5378 3.4678 2.5285 5.1494 1.0658 1.8015 2.1719 3.5738 3.2677 5.3452 0.67634-1.1566 1.3499-2.3276 2.0098-3.4539 0.1804-0.32984 0.38943-0.65968 0.56913-0.97498 0.11988-0.2109 0.35002-0.42063 0.45441-0.61581 1.0658-1.9518 2.7823-3.9184 2.7823-5.8557v-0.79551c0-0.20973-0.2604-0.94565-0.27494-0.99046zm-5.5754 3.6179c-0.75047 0-1.5715-0.37488-1.9767-1.4113-0.060525-0.16492-0.055834-0.4957-0.055834-0.52596v-0.46567c0-1.3205 1.1216-1.9216 2.0975-1.9216 1.2007 0 2.1299 0.96137 2.1299 2.1627s-0.99351 2.1618-2.1949 2.1618z" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'MINUS':
      return (
        <svg viewBox="0 0 14 3" width={14} height={3}>
          <g fill="none" fillRule="evenOdd">
            <g transform="translate(-40 -517)" fill="#3395FE">
              <g transform="translate(0 144)">
                <g transform="translate(24 323)">
                  <g transform="translate(0 28)">
                    <polygon points="16 25 16 22 30 22 30 25" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )

    case 'PLUS':
      return (
        <svg width={14} height={14} viewBox="0, 0, 14, 14">
          <g>
            <path
              d="M8.5,0 L8.5,5.5 L14,5.5 L14,8.5 L8.5,8.5 L8.5,14 L5.5,14 L5.5,8.5 L0,8.5 L0,5.5 L5.5,5.5 L5.5,0 L8.5,0 z"
              fill="#3395FE"
            />
          </g>
        </svg>
      )
    case 'PLUS-LIGHT':
      return (
        <svg width={14} height={14} viewBox="0, 0, 14, 14">
          <g>
            <path
              d="M8.5,0 L8.5,5.5 L14,5.5 L14,8.5 L8.5,8.5 L8.5,14 L5.5,14 L5.5,8.5 L0,8.5 L0,5.5 L5.5,5.5 L5.5,0 L8.5,0 z"
              fill="#EFF0F3"
            />
          </g>
        </svg>
      )
    case 'PLUS-SM':
      return (
        <svg width={9} height={9} viewBox="0, 0, 14, 14">
          <g>
            <path
              d="M8.5,0 L8.5,5.5 L14,5.5 L14,8.5 L8.5,8.5 L8.5,14 L5.5,14 L5.5,8.5 L0,8.5 L0,5.5 L5.5,5.5 L5.5,0 L8.5,0 z"
              fill="#3395fe"
            />
          </g>
        </svg>
      )
    case 'RIGHT-ARROW-SM':
      return (
        <svg width="6" height="12" viewBox="0 0 6 12">
          <g fill="none" fillRule="evenOdd">
            <path d="M-3 0H9v12H-3z" />
            <path
              fill="#3395FE"
              stroke="#3395FE"
              strokeWidth=".6"
              d="M.674 1L0 1.67 4.612 6 0 10.329.674 11 6 6z"
            />
          </g>
        </svg>
      )
    case 'DOWN_ARROW':
      return (
        <svg width={18} height={14} viewBox="0, 0, 12, 8">
          <g>
            <path d="M6,8 L0,0 L12,0 z" fill={color || '#006ee5'} />
          </g>
        </svg>
      )

    case 'UP_ARROW':
      return (
        <svg width={18} height={14} viewBox="0, 0, 12, 8">
          <g>
            <path d="M6,0 L0,8 L12,8 z" fill={color || '#006ee5'} />
          </g>
        </svg>
      )

    case 'CANCEL':
      return (
        <svg width={14} height={14} viewBox="0, 0, 14, 14">
          <g>
            <path
              d="M1.421,1.405 L12.743,12.727"
              fillOpacity="0"
              stroke="#D1D3DB"
              strokeWidth="2.5"
              strokeLinecap="round"
              id="Path-2"
            />
            <path
              d="M12.743,1.405 L1.421,12.727 L12.743,1.405 z"
              fillOpacity="0"
              stroke="#D1D3DB"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              id="Path-2"
            />
          </g>
        </svg>
      )

    case 'CANCEL-DP':
      return (
        <svg width={17} height={17} viewBox="0, 0, 14, 14">
          <g>
            <path
              d="M1.421,1.405 L12.743,12.727"
              fillOpacity="0"
              stroke="#A4A9B7"
              strokeWidth="2"
              strokeLinecap="round"
              id="Path-2"
            />
            <path
              d="M12.743,1.405 L1.421,12.727 L12.743,1.405 z"
              fillOpacity="0"
              stroke="#A4A9B7"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              id="Path-2"
            />
          </g>
        </svg>
      )

    case 'CLEAR-SEARCH':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <defs>
            <path id="d" d="M0 0h12v12H0z" />
          </defs>
          <g fill="none" fillRule="evenOdd">
            <rect width="24" height="24" rx="4" fill="#A4A9B7" />
            <g
              transform="translate(6 6)"
              opacity=".849"
              stroke="#FFF"
              strokeLinecap="round"
              strokeWidth="1.5"
            >
              <path d="m1.218 1.204l9.705 9.705" mask="url(#c)" />
              <path
                d="M10.923 1.204L1.218 10.91l9.705-9.705z"
                mask="url(#c)"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </svg>
      )

    case 'CLEAR-SEARCH-SM':
      return (
        <svg width="16" height="16" viewBox="0 0 16 16">
          <defs>
            <path id="d" d="M0 0h8v8H0z" />
          </defs>
          <g fill="none" fillRule="evenOdd">
            <rect width="16" height="16" rx="4" fill="#A4A9B7" />
            <g
              transform="translate(4 4)"
              opacity=".849"
              stroke="#FFF"
              strokeLinecap="round"
              strokeWidth="1.5"
            >
              <path d="M.812.803l6.47 6.47" mask="url(#c)" />
              <path
                d="M7.282.803l-6.47 6.47 6.47-6.47z"
                mask="url(#c)"
                strokeLinejoin="round"
              />
            </g>
          </g>
        </svg>
      )

    case 'SEARCH-GREY':
      return (
        <svg width="16" height="17" viewBox="0 0 16 17">
          <path
            fill="#3e4044"
            fillRule="nonzero"
            d="M15.794 15.697l-3.735-3.874a7.042 7.042 0 0 0 1.868-4.785C13.887 3.123 10.777-.022 6.97 0 3.157-.03.04 3.118 0 7.038c.04 3.92 3.157 7.068 6.97 7.038a6.88 6.88 0 0 0 3.941-1.238l3.792 3.94a.753.753 0 0 0 1.067 0 .78.78 0 0 0 .024-1.08zM1.524 7.038c.035-3.06 2.47-5.513 5.446-5.488 2.975-.024 5.408 2.43 5.444 5.488-.036 3.058-2.47 5.512-5.444 5.488-2.976.025-5.411-2.428-5.446-5.488z"
          />
        </svg>
      )

    case 'SELECT-ARROW':
      return (
        <svg width="11" height="18" viewBox="0 0 11 18">
          <g fill="none" fillRule="evenOdd">
            <path d="M-6 0h18v18H-6z" />
            <path
              stroke="#3395FE"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M2.071 16.142l7.071-7.07L2.072 2"
            />
          </g>
        </svg>
      )

    case 'DONE':
      return (
        <svg width={20} height={20} viewBox="0, 0, 16, 16">
          <g>
            <path
              d="M1.766,6.297 L6.516,11.281"
              fillOpacity="0"
              stroke="#ff552e"
              strokeWidth="3"
            />
            <path
              d="M6.516,11.281 L1.766,6.297"
              fillOpacity="0"
              stroke="#ff552e"
              strokeWidth="3"
            />
            <path
              d="M5.937,9.766 L12.406,3.219 z"
              fillOpacity="0"
              stroke="#ff552e"
              strokeWidth="3"
            />
          </g>
        </svg>
      )
    case 'OFFICE_EQUIPMENT':
      return (
        <svg viewBox="0, 0, 66, 58">
          <g>
            <path
              d="M51.596,10.213 L55.638,10.213 L55.638,3.745 L51.596,3.745 z"
              fill="#3395FE"
              fillOpacity="0.3"
            />
            <path
              d="M7.128,42.553 L11.979,42.553 L11.979,28 L7.128,28 z"
              fill="#3395FE"
              fillOpacity="0.3"
            />
            <path
              d="M55.638,57.106 L20.064,57.106 L20.064,50.638 L47.553,50.638 L47.553,28 L52.404,28 L52.404,24.766 L7.128,24.766 L7.128,16.681 L65.34,16.681 L65.34,45.787 L55.638,45.787 L55.638,57.106"
              fill="#3395FE"
              fillOpacity="0.3"
            />
            <path
              d="M20.064,39.319 L39.468,39.319 L39.468,36.085 L20.064,36.085 z"
              fill="#3395FE"
            />
            <path
              d="M48.362,19.915 L51.596,19.915 L51.596,16.681 L48.362,16.681 z"
              fill="#3395FE"
            />
            <path
              d="M38.66,19.915 L45.128,19.915 L45.128,16.681 L38.66,16.681 z"
              fill="#3395FE"
            />
            <path
              d="M55.638,42.553 L47.553,42.553 L47.553,28 L52.404,28 L52.404,24.766 L7.128,24.766 L7.128,28 L11.979,28 L11.979,42.553 L3.894,42.553 L3.894,13.447 L55.638,13.447 L55.638,42.553 z M44.319,42.553 L44.319,50.638 L15.213,50.638 L15.213,28 L44.319,28 L44.319,42.553 z M11.17,10.213 L48.362,10.213 L48.362,3.745 L11.17,3.745 L11.17,10.213 z M51.596,10.213 L51.596,0.511 L7.936,0.511 L7.936,10.213 L0.66,10.213 L0.66,45.787 L11.979,45.787 L11.979,53.872 L47.553,53.872 L47.553,45.787 L58.872,45.787 L58.872,10.213 L51.596,10.213 z"
              fill="#3395FE"
            />
            <path
              d="M20.064,45.787 L39.468,45.787 L39.468,42.553 L20.064,42.553 z"
              fill="#3395FE"
            />
          </g>
        </svg>
      )

    case 'TEMPERATURE':
      return (
        <svg viewBox="0, 0, 64, 57">
          <g>
            <path
              d="M37.66,56.915 C31.024,56.915 25.563,51.916 24.817,45.48 C26.438,48.208 29.405,50.043 32.809,50.043 C37.944,50.043 42.106,45.88 42.106,40.745 C42.106,36.749 39.581,33.351 36.043,32.037 L36.043,31.155 C36.573,31.089 37.111,31.043 37.66,31.043 C38.209,31.043 38.746,31.089 39.277,31.155 L39.277,6.787 L44.128,6.787 L44.128,32.787 C47.99,35.025 50.596,39.193 50.596,43.979 C50.596,51.124 44.804,56.915 37.66,56.915"
              fill="#C1DFFE"
              id="Fill-39"
            />
            <path
              d="M34.426,13.255 L31.191,13.255 L31.191,35.32 C28.855,36.015 27.149,38.182 27.149,40.745 C27.149,43.874 29.68,46.404 32.809,46.404 C35.937,46.404 38.468,43.874 38.468,40.745 C38.468,38.182 36.762,36.015 34.426,35.32 L34.426,13.255"
              fill="#3395FE"
              id="Fill-40"
            />
            <path
              d="M42.106,40.745 C42.106,45.879 37.943,50.043 32.809,50.043 C32.598,50.043 32.388,50.034 32.178,50.018 C32.016,50.01 31.854,49.994 31.693,49.978 L31.636,49.97 C31.466,49.946 31.297,49.921 31.135,49.889 L30.933,49.857 C30.739,49.816 30.545,49.768 30.351,49.711 C30.14,49.654 29.93,49.59 29.72,49.517 C29.356,49.388 29.009,49.242 28.669,49.064 C28.491,48.983 28.313,48.886 28.143,48.781 C27.974,48.684 27.804,48.587 27.642,48.466 L27.61,48.45 C27.456,48.353 27.311,48.24 27.165,48.126 C27.003,48.013 26.85,47.884 26.704,47.746 C26.405,47.496 26.122,47.213 25.863,46.914 C25.597,46.623 25.354,46.307 25.136,45.984 C25.023,45.83 24.917,45.677 24.82,45.507 L24.82,45.499 C23.988,44.108 23.511,42.483 23.511,40.745 C23.511,36.751 26.033,33.355 29.574,32.037 L29.574,3.553 L36.043,3.553 L36.043,32.037 C39.584,33.355 42.106,36.751 42.106,40.745 z M60.934,23.504 L59.89,27.029 L59.958,26.741 C55.131,25.577 49.779,24.736 44.128,24.259 C42.535,24.122 40.918,24.017 39.277,23.936 L39.277,0.319 L26.34,0.319 L26.34,23.895 C18.598,24.227 11.267,25.188 4.859,26.74 L3.958,23.507 L0.841,24.376 L3.447,33.727 L6.563,32.858 L5.727,29.858 C11.875,28.379 18.904,27.458 26.34,27.137 L26.34,29.555 C22.476,31.794 19.872,35.958 19.872,40.745 C19.872,46.291 23.357,51.013 28.257,52.856 C29.671,53.39 31.208,53.681 32.809,53.681 C39.956,53.681 45.745,47.892 45.745,40.745 C45.745,35.958 43.141,31.794 39.277,29.555 L39.277,27.17 C40.918,27.251 42.535,27.364 44.128,27.509 C49.453,27.965 54.492,28.763 59.054,29.851 L58.176,32.812 L61.279,33.73 L64.036,24.423 L60.934,23.504 z"
              fill="#3395FE"
              id="Fill-41"
            />
          </g>
        </svg>
      )

    case 'GENERAL_MAINTENANCE':
      return (
        <svg viewBox="0, 0, 68, 71">
          <g id="Requests">
            <path
              d="M51.787,70.383 C49.168,70.383 46.912,68.823 45.893,66.575 C45.521,65.758 45.319,64.861 45.319,63.915 L45.319,60.681 C45.319,62.468 46.766,63.915 48.553,63.915 C50.34,63.915 51.787,62.468 51.787,60.681 L51.787,43.84 L56.832,38.794 C57.754,37.881 58.255,36.66 58.255,35.366 L58.255,29.149 L64.723,29.149 L64.723,38.6 C64.723,40.759 63.883,42.789 62.354,44.317 L58.255,48.416 L58.255,55.021 L67.957,55.021 L67.957,63.106 L58.255,63.106 L58.255,63.915 C58.255,67.48 55.353,70.383 51.787,70.383"
              fill="#C1DFFE"
              id="Fill-12"
            />
            <path
              d="M6.511,63.106 L44.511,63.106 L44.511,55.021 L6.511,55.021 z"
              fill="#C1DFFE"
              id="Fill-13"
            />
            <path
              d="M42.085,50.17 L9.745,50.17 L9.745,24.298 L18.946,24.298 L18.646,24.403 L20.587,32.892 L27.136,32.14 C28.041,33.725 29.197,35.172 30.548,36.401 L28.356,42.627 L36.199,46.403 L38.932,42.029 L42.085,45.182 L42.085,50.17"
              fill="#C1DFFE"
              id="Fill-14"
            />
            <path
              d="M9.745,24.298 L12.979,24.298 L12.979,21.064 L9.745,21.064 z"
              fill="#3395FE"
              id="Fill-15"
            />
            <path
              d="M14.596,24.298 L17.83,24.298 L17.83,21.064 L14.596,21.064 z"
              fill="#3395FE"
              id="Fill-16"
            />
            <path
              d="M55.021,56.638 L61.489,56.638 L61.489,53.404 L55.021,53.404 L55.021,56.638 z M51.787,43.84 L51.787,60.681 C51.787,62.468 50.34,63.915 48.553,63.915 C46.766,63.915 45.319,62.468 45.319,60.681 L45.319,43.84 L40.274,38.794 C39.352,37.881 38.851,36.66 38.851,35.366 L38.851,29.149 L42.085,29.149 L42.085,36.28 L48.553,42.821 L55.021,36.28 L55.021,29.149 L58.255,29.149 L58.255,35.366 C58.255,36.66 57.754,37.881 56.832,38.794 L51.787,43.84 z M42.085,50.17 L6.511,50.17 L6.511,17.83 L25.764,17.83 C25.283,19.25 24.98,20.719 24.879,22.232 L18.649,24.405 L20.584,32.89 L27.139,32.14 C28.043,33.723 29.199,35.17 30.545,36.403 L28.355,42.627 L36.199,46.401 L38.934,42.029 L42.085,45.182 L42.085,50.17 z M3.277,56.638 L42.085,56.638 L42.085,53.404 L3.277,53.404 L3.277,56.638 z M55.021,50.17 L55.021,45.182 L59.12,41.083 C60.649,39.554 61.489,37.525 61.489,35.366 L61.489,25.915 L51.787,25.915 L51.787,34.954 L48.577,38.204 L48.553,38.229 L45.319,34.954 L45.319,25.915 L35.617,25.915 L35.617,35.366 C35.617,36.827 36.01,38.224 36.732,39.45 L34.993,42.231 L32.367,40.969 L34.344,35.349 L33.447,34.632 C31.793,33.31 30.43,31.605 29.508,29.703 L29.008,28.67 L23.093,29.348 L22.445,26.507 L28.07,24.544 L28.073,23.4 C28.079,21.239 28.551,19.17 29.474,17.249 L29.972,16.215 L25.755,12.006 L27.572,9.729 L32.611,12.901 L33.508,12.189 C35.201,10.845 37.114,9.927 39.188,9.458 L40.314,9.205 L40.97,3.277 L43.883,3.277 L44.54,9.205 L45.665,9.458 C47.74,9.927 49.651,10.845 51.345,12.189 L52.242,12.901 L57.281,9.729 L59.099,12.006 L54.881,16.215 L55.379,17.249 C56.303,19.17 56.774,21.239 56.781,23.4 L60.015,23.39 C60.008,21.137 59.587,18.963 58.762,16.911 L63.431,12.25 L58.004,5.452 L52.425,8.965 C50.907,7.911 49.259,7.119 47.505,6.598 L46.778,0.043 L38.076,0.043 L37.349,6.598 C35.594,7.119 33.947,7.911 32.428,8.965 L26.849,5.452 L21.421,12.25 L23.772,14.596 L3.277,14.596 L3.277,50.17 L0.043,50.17 L0.043,59.872 L42.085,59.872 L42.085,60.681 C42.085,63.3 43.646,65.556 45.893,66.575 C46.71,66.947 47.607,67.149 48.553,67.149 C52.119,67.149 55.021,64.246 55.021,60.681 L55.021,59.872 L64.723,59.872 L64.723,50.17 L55.021,50.17 z"
              fill="#3395FE"
              id="Fill-17"
            />
            <path
              d="M46.936,59.872 L50.17,59.872 L50.17,56.638 L46.936,56.638 z"
              fill="#3395FE"
              id="Fill-18"
            />
          </g>
        </svg>
      )

    case 'LOCK_KEY':
      return (
        <svg viewBox="0, 0, 58, 66">
          <g>
            <path
              d="M20.915,16.638 L17.681,16.638 L17.681,3.702 L46.787,3.702 L46.787,13.404 L43.553,13.404 L43.553,6.936 L20.915,6.936 L20.915,16.638"
              fill="#C1DFFE"
              id="Fill-19"
            />
            <path
              d="M23.34,65.149 L10.404,65.149 L10.404,58.681 L16.872,58.681 L16.872,55.447 L13.638,55.447 L13.638,38.306 C14.835,38.064 15.934,37.554 16.872,36.843 C18.837,35.371 20.106,33.019 20.106,30.383 C20.106,26.429 17.252,23.131 13.493,22.435 L13.638,22.411 C14.164,22.338 14.706,22.298 15.255,22.298 C17.551,22.298 19.686,22.985 21.473,24.166 C24.545,26.187 26.574,29.671 26.574,33.617 C26.574,38.129 23.923,42.026 20.106,43.845 L20.106,48.979 L50.83,48.979 L50.83,19.872 L57.298,19.872 L57.298,55.447 L23.34,55.447 L23.34,65.149"
              fill="#C1DFFE"
              id="Fill-20"
            />
            <path
              d="M27.383,30.446 L27.383,39.277 L30.617,39.277 L30.617,30.446 C32.044,29.822 33.043,28.401 33.043,26.745 C33.043,24.512 31.232,22.702 29,22.702 C26.768,22.702 24.957,24.512 24.957,26.745 C24.957,28.401 25.956,29.822 27.383,30.446"
              fill="#3395FE"
              id="Fill-21"
            />
            <path
              d="M16.872,55.447 L16.872,58.681 L10.404,58.681 L10.404,38.306 C9.208,38.064 8.108,37.554 7.17,36.843 C5.586,35.654 4.454,33.892 4.074,31.871 C3.985,31.386 3.936,30.892 3.936,30.383 C3.936,27.747 5.206,25.394 7.17,23.923 C8.108,23.211 9.208,22.702 10.404,22.46 C10.922,22.354 11.463,22.298 12.021,22.298 C12.523,22.298 13.016,22.346 13.493,22.435 C17.252,23.131 20.106,26.429 20.106,30.383 C20.106,33.019 18.837,35.371 16.872,36.843 C15.934,37.554 14.835,38.064 13.638,38.306 L13.638,55.447 L16.872,55.447 z M10.404,16.638 L47.596,16.638 L47.596,45.745 L16.872,45.745 L16.872,40.611 C20.689,38.791 23.34,34.894 23.34,30.383 C23.34,28.087 22.653,25.952 21.473,24.166 C19.451,21.093 15.967,19.064 12.021,19.064 C11.471,19.064 10.93,19.104 10.404,19.177 L10.404,16.638 z M50.83,48.979 L50.83,13.404 L17.681,13.404 L17.681,3.702 L40.319,3.702 L40.319,10.17 L43.553,10.17 L43.553,0.468 L14.447,0.468 L14.447,13.404 L7.17,13.404 L7.17,20.155 C3.354,21.974 0.702,25.871 0.702,30.383 C0.702,34.337 2.74,37.821 5.812,39.851 C6.249,40.126 6.701,40.384 7.17,40.611 L7.17,61.915 L20.106,61.915 L20.106,52.213 L16.872,52.213 L16.872,48.979 L50.83,48.979 z"
              fill="#3395FE"
              id="Fill-22"
            />
            <path
              d="M12.021,32 C11.132,32 10.404,31.272 10.404,30.383 C10.404,29.494 11.132,28.766 12.021,28.766 C12.911,28.766 13.638,29.494 13.638,30.383 C13.638,31.272 12.911,32 12.021,32 z M16.395,32.477 C16.703,31.846 16.872,31.135 16.872,30.383 C16.872,27.707 14.697,25.532 12.021,25.532 C11.455,25.532 10.914,25.629 10.404,25.815 C8.52,26.47 7.17,28.273 7.17,30.383 C7.17,32.493 8.52,34.296 10.404,34.951 C10.914,35.137 11.455,35.234 12.021,35.234 C12.773,35.234 13.485,35.064 14.115,34.757 C15.11,34.28 15.918,33.471 16.395,32.477 z"
              fill="#3395FE"
              id="Fill-23"
            />
          </g>
        </svg>
      )

    case 'ELECTRICITY':
      return (
        <svg viewBox="0, 0, 58, 61">
          <g>
            <path
              d="M27.383,38.697 L11.52,38.697 L13.549,35.463 L27.383,35.463 L27.383,38.697"
              fill="#C1DFFE"
              id="Fill-40"
            />
            <g id="Group-44">
              <path
                d="M33.851,22.526 L30.617,22.526 L30.617,8.313 L33.851,3.171 L33.851,22.526"
                fill="#C1DFFE"
                id="Fill-41"
              />
              <path
                d="M30.617,60.34 L30.617,52.11 L47.669,25.76 L52.997,25.76 L30.617,60.34"
                fill="#C1DFFE"
                id="Fill-43"
              />
            </g>
            <path
              d="M10.327,11.812 L2.478,6.11 L0.578,8.726 L8.427,14.428 L10.327,11.812"
              fill="#3395FE"
              id="Fill-45"
            />
            <path
              d="M49.573,40.327 L57.422,46.029 L55.522,48.645 L47.673,42.943 L49.573,40.327"
              fill="#3395FE"
              id="Fill-46"
            />
            <path
              d="M47.673,11.812 L55.522,6.11 L57.422,8.726 L49.573,14.428 L47.673,11.812"
              fill="#3395FE"
              id="Fill-47"
            />
            <path
              d="M8.427,40.327 L0.578,46.029 L2.478,48.645 L10.327,42.943 L8.427,40.327"
              fill="#3395FE"
              id="Fill-48"
            />
            <path
              d="M14.139,32.229 L30.617,32.229 L30.617,46.158 L43.814,25.76 L27.383,25.76 L27.383,11.159 L14.139,32.229 z M27.383,57.108 L27.383,35.463 L8.287,35.463 L30.617,-0.063 L30.617,22.526 L49.76,22.526 L27.383,57.108 z"
              fill="#3395FE"
              id="Fill-49"
            />
          </g>
        </svg>
      )

    case 'PLUMBING':
      return (
        <svg viewBox="0, 0, 72, 73">
          <g>
            <path
              d="M3.3,71.3 C0.7,70 0,69 0,66.8 C0,63.6 1.2,63.3 5.4,65.5 C8.9,67.4 10.1,67.4 13.6,65.5 C17.4,63.6 21.1,63.6 25.5,65.7 C28.8,67.3 29.2,67.3 32.5,65.7 C34.5,64.8 37.2,64 38.5,64 C39.8,64 42.5,64.8 44.5,65.7 C47.8,67.3 48.2,67.3 51.5,65.7 C56,63.6 59,63.6 63.4,65.7 C66.3,67 67.4,67.1 69.5,66.2 C72.1,65 72.1,65 71.8,68.7 C71.5,72.4 71.4,72.5 67.5,72.4 C65.3,72.4 62.1,71.7 60.4,71 C57.7,69.8 56.8,69.9 53.7,71.3 C49.3,73.4 46.7,73.4 42.3,71.3 C39.3,69.9 38.3,69.8 35.6,70.9 C30.1,73.2 28.2,73.3 23.2,71.5 C18.7,69.9 18.2,69.9 15.2,71.4 C11.3,73.4 7.5,73.4 3.3,71.3 z"
              fill="#3395FE"
            />
            <path
              d="M9,51 C9,49.3 8.3,49 4.5,49 L0,49 L0,36.6 L0,24.2 L3.1,21.6 C6.1,19.1 6.6,19 19.6,19 L33,19 L33,16.5 C33,14.1 33.3,14 39,14 L45,14 L45,10 L45,6 L39,6 L33,6 L33,3 L33,0 L48,0 L63,0 L63,3 L63,6 L57,6 L51,6 L51,10 L51,14 L57,14 C62.7,14 63,14.1 63,16.5 C63,18.8 63.4,19 67.5,19 C71.8,19 72,19.1 72,22 C72,24.9 71.8,25 67.5,25 C63.7,25 63,25.3 63,27 C63,28.7 63.7,29 67.5,29 L72,29 L72,36.5 C72,43.3 71.8,44 70,44 C68.5,44 68,44.7 68,46.5 L68,49 L53,49 L38,49 L38,46.5 C38,44.2 37.6,44 33.5,44 L29,44 L29,48.5 L29,53 L19,53 C9.7,53 9,52.9 9,51 z M9.2,36.3 L9.5,29.5 L21.3,29.2 C32.2,29 33,28.8 33,27 C33,25.1 32.3,25 20.6,25 C5.2,25 5,25.1 5,35.6 C5,42.3 5.2,43 7,43 C8.7,43 8.9,42.2 9.2,36.3 z M42.6,33.5 L40.1,28.9 L42.2,25.5 C43.9,22.5 44.7,22 48,22 C51.4,22 52.1,22.4 54.4,26.3 L56.9,30.5 L57,25.3 L57,20 L48,20 L39,20 L39,29 L39,38 L42.1,38 L45.2,38 L42.6,33.5 z"
              fill="#3395FE"
            />
          </g>
          <g id="layer102">
            <path
              d="M9,50.5 C9,48.2 9.3,48 14,48 L19,48 L19,43.5 L19,39 L25.9,39 C32.4,39 32.8,39.1 33.2,41.5 C33.6,43.6 33.3,44 31.4,44 C29.2,44 29,44.4 29,48.5 L29,53 L19,53 L9,53 L9,50.5 z"
              fill="#BDDDFC"
            />
            <path
              d="M38.2,46.3 L38.5,43.5 L50.4,43.2 C61,43 62.3,42.7 62.7,41.1 C63.1,39.7 64.3,39.1 67.6,38.8 C71.8,38.5 72,38.6 72,41.2 C72,43.3 71.5,44 70,44 C68.5,44 68,44.7 68,46.5 L68,49 L52.9,49 L37.9,49 L38.2,46.3 z"
              fill="#BDDDFC"
            />
            <path
              d="M9.2,36.3 L9.5,29.5 L21.1,29.2 C32,29 32.8,29.1 33.3,30.9 C33.6,32 33.5,33.1 33.2,33.4 C32.9,33.7 28.5,34 23.3,34 L14,34 L14,38.5 C14,42.7 13.8,43 11.5,43 C8.9,43 8.9,42.9 9.2,36.3 z"
              fill="#BDDDFC"
            />
            <path
              d="M44.7,37.3 C43.1,35.8 44.2,35 48,35 C51.4,35 52.2,34.6 53.6,31.9 C55.5,28.2 56.8,29 57.7,34.3 L58.3,38 L51.8,38 C48.2,38 45,37.7 44.7,37.3 z"
              fill="#BDDDFC"
            />
            <path
              d="M62.8,33.4 C62.5,33.1 62.4,32 62.7,30.9 C63.1,29.4 64.1,29 67.6,29 C71.6,29 72,29.2 72,31.5 C72,33.8 71.6,34 67.7,34 C65.3,34 63.1,33.7 62.8,33.4 z"
              fill="#BDDDFC"
            />
          </g>
        </svg>
      )

    case 'GROUNDS':
      return (
        <svg viewBox="0, 0, 68, 57">
          <g>
            <path
              d="M54.213,39.511 C47.069,39.511 41.277,33.719 41.277,26.574 C41.277,19.43 47.069,13.638 54.213,13.638 C61.358,13.638 67.149,19.43 67.149,26.574 C67.149,33.719 61.358,39.511 54.213,39.511"
              fill="#C1DFFE"
              id="Fill-74"
            />
            <path
              d="M14.191,50.83 C9.949,50.83 6.511,47.209 6.511,42.745 C6.511,38.28 9.949,34.66 14.191,34.66 C18.434,34.66 21.872,38.28 21.872,42.745 C21.872,47.209 18.434,50.83 14.191,50.83"
              fill="#C1DFFE"
              id="Fill-75"
            />
            <path
              d="M33.191,54.266 L35.415,56.489 L42.085,49.819 L39.862,47.596 L33.191,54.266"
              fill="#3395FE"
              id="Fill-76"
            />
            <path
              d="M45.319,54.266 L47.542,56.489 L54.213,49.819 L51.99,47.596 L45.319,54.266"
              fill="#3395FE"
              id="Fill-77"
            />
            <g id="Group-81">
              <path
                d="M2.448,4.122 L62.318,4.122 L62.318,0.888 L2.448,0.888 z"
                fill="#3395FE"
                id="Fill-78"
              />
              <path
                d="M51.142,33.229 C48.636,33.229 46.328,32.378 44.462,30.962 L54.997,20.292 L40.094,20.292 C40.873,14.816 45.523,10.59 51.142,10.59 C57.305,10.59 62.318,15.668 62.318,21.909 C62.318,28.151 57.305,33.229 51.142,33.229 z M40.094,23.526 L47.288,23.526 L42.204,28.675 C41.109,27.195 40.367,25.439 40.094,23.526 z M4.044,39.697 C4.044,36.13 6.909,33.229 10.43,33.229 C13.952,33.229 16.817,36.13 16.817,39.697 C16.817,43.263 13.952,46.165 10.43,46.165 C6.909,46.165 4.044,43.263 4.044,39.697 z M59.125,41.314 L30.457,41.314 L20.079,53.441 L5.641,53.441 L5.641,48.091 C7.051,48.917 8.684,49.399 10.43,49.399 C15.721,49.399 20.01,45.055 20.01,39.697 C20.01,34.339 15.721,29.994 10.43,29.994 C8.684,29.994 7.051,30.476 5.641,31.303 L5.641,13.824 L24.799,13.824 L24.799,33.229 L27.992,33.229 L27.992,13.824 L39.211,13.824 C37.96,15.716 37.127,17.915 36.867,20.292 L35.177,20.292 L35.177,23.526 L36.867,23.526 C37.174,26.333 38.269,28.894 39.922,30.987 L37.241,33.702 L39.499,35.989 L42.18,33.274 C44.638,35.265 47.751,36.463 51.142,36.463 C54.097,36.463 56.842,35.557 59.125,34.009 L59.125,41.314 z M51.142,7.356 C47.727,7.356 44.6,8.574 42.136,10.59 L2.448,10.59 L2.448,34.338 C1.44,35.873 0.851,37.715 0.851,39.697 C0.851,41.678 1.44,43.52 2.448,45.055 L2.448,56.675 L21.537,56.675 L31.914,44.548 L62.318,44.548 L62.318,31.047 C64.312,28.549 65.511,25.372 65.511,21.909 C65.511,13.872 59.078,7.356 51.142,7.356 z"
                fill="#3395FE"
                id="Fill-80"
              />
            </g>
          </g>
        </svg>
      )

    case 'HOUSEKEEPING':
      return (
        <svg viewBox="0 0 70 65">
          <path
            d="m36.84 35.611h-2.425l5.566-31.531h4.848l-5.27 29.899-0.794 0.476-1.925 1.156m-5.659 0h-1.612l5.557-31.531h1.617l-5.562 31.531"
            fill="#C1DFFE"
          />
          <path
            d="m53.754 52.663l-2.085-3.485 0.679-1.14 1.14-1.9c1.229-2.045 2.951-3.767 4.995-4.996l6.526-3.913-6.526-3.914c-2.044-1.229-3.766-2.951-4.995-4.996l-1.14-1.9-0.679-1.14 2.085-3.485 3.914 6.525c1.22 2.045 2.951 3.767 4.988 4.996l1.908 1.14 4.625 2.774-4.625 2.773-1.908 1.14c-2.037 1.229-3.768 2.951-4.988 4.996l-3.914 6.525m-3.985-6.622l0.945-1.568c1.504-2.507 3.598-4.601 6.105-6.104l1.9-1.14-1.9 1.14c-2.507 1.503-4.601 3.597-6.105 6.104l-0.194 0.323-0.751 1.245"
            fill="#C1DFFE"
          />
          <path
            d="m22.489 22.271l-0.605-1.01c-0.797-1.327-1.908-2.439-3.236-3.235l-1.01-0.606 1.01-0.606c1.328-0.796 2.439-1.908 3.236-3.235l0.605-1.01 0.606 1.01c0.796 1.327 1.908 2.439 3.236 3.235l1.009 0.606-1.009 0.606c-1.328 0.796-2.44 1.908-3.236 3.235l-0.606 1.01"
            fill="#C1DFFE"
          />
          <path
            d="m9.149 33.194c-0.963-1.197-2.046-2.28-3.242-3.242 1.196-0.962 2.279-2.046 3.242-3.242 0.962 1.196 2.045 2.28 3.242 3.242-1.197 0.962-2.28 2.045-3.242 3.242m7.244-4.382c-2.256-1.35-4.172-3.178-5.627-5.361-0.17-0.242-0.323-0.493-0.477-0.743l-1.14-1.9-1.14 1.9c-1.504 2.506-3.598 4.6-6.104 6.104l-1.9 1.14 1.9 1.14c2.506 1.503 4.6 3.598 6.104 6.104l1.14 1.9 1.14-1.9c0.154-0.25 0.307-0.501 0.477-0.744 1.455-2.183 3.371-4.01 5.627-5.36l1.9-1.14-1.9-1.14"
            fill="#3395FE"
          />
          <path
            d="m12.383 39.096l-1.14-1.9c-0.154-0.25-0.307-0.501-0.477-0.744 1.455-2.183 3.371-4.01 5.627-5.36l1.9-1.14-1.9-1.14c-2.256-1.35-4.172-3.178-5.627-5.361 0.17-0.242 0.323-0.493 0.477-0.743l1.14-1.9 1.14 1.9c1.504 2.506 3.598 4.6 6.104 6.104l1.9 1.14-1.9 1.14c-1.957 1.175-3.664 2.709-5.034 4.519h-0.496l-0.164 0.935c-0.142 0.214-0.278 0.43-0.41 0.65l-1.14 1.9"
            fill="#C1DFFE"
          />
          <path
            d="m10.766 36.452c-1.455-2.183-3.372-4.01-5.627-5.36l-1.9-1.14 1.9-1.14c2.255-1.35 4.172-3.178 5.627-5.361 1.455 2.183 3.371 4.011 5.627 5.361l1.9 1.14-1.9 1.14c-2.256 1.35-4.172 3.177-5.627 5.36m-4.859-6.5c1.196 0.962 2.279 2.045 3.242 3.242 0.962-1.197 2.045-2.28 3.242-3.242-1.197-0.962-2.28-2.046-3.242-3.242-0.963 1.196-2.046 2.28-3.242 3.242"
            fill="#3395FE"
          />
          <path d="m52 64.718h6.468v-3.234h-6.468z" fill="#3395FE" />
          <path
            d="m19.054 20.857l0.606 1.01 0.605-1.01c0.797-1.328 1.908-2.439 3.236-3.236l1.01-0.605-1.01-0.606c-1.328-0.796-2.439-1.908-3.236-3.235l-0.605-1.01-0.606 1.01c-0.796 1.327-1.908 2.439-3.236 3.235l-1.009 0.606 1.009 0.605c1.328 0.797 2.44 1.908 3.236 3.236"
            fill="#3395FE"
          />
          <path
            d="m56.819 38.369c-2.507 1.503-4.601 3.597-6.105 6.104l-0.194 0.323-0.751 1.245-0.195 0.332-1.14-1.9c-0.202-0.332-0.412-0.655-0.631-0.97-0.347-0.494-0.711-0.971-1.099-1.423-0.355-0.421-0.735-0.825-1.132-1.205-0.978-0.962-2.061-1.803-3.242-2.506l-1.9-1.14 1.9-1.14c0.251-0.154 0.501-0.308 0.744-0.478 1.868-1.245 3.484-2.829 4.754-4.681 0.21-0.307 0.412-0.622 0.606-0.946l1.14-1.9 0.195 0.332 0.945 1.568c1.504 2.507 3.598 4.601 6.105 6.105l1.9 1.14-1.9 1.14m-40.571 3.711l0.566-3.234h20.026l1.925 1.156 1.9 1.14c0.477 0.291 0.929 0.606 1.366 0.938h-25.783m23.592 12.726c-0.687 3.864-4.034 6.678-7.964 6.678h-11.675c1.27-1.512 2.143-3.55 2.596-6.121l0.776-4.39h-3.291l-0.671 3.833c-0.138 0.768-0.307 1.463-0.534 2.085-0.42 1.27-1.026 2.256-1.819 2.984l-0.016 0.016c-1.18 1.083-2.781 1.593-4.859 1.593h-1.698c1.633-1.609 2.789-3.719 3.218-6.121l1.771-10.049h13.849l-1.706 9.702h3.234l1.706-9.702h8.757l-1.674 9.492m-6.331-50.726h3.234l-5.562 31.531h-3.234l5.562-31.531m26.875 30.375l-1.901-1.14c-2.044-1.229-3.766-2.951-4.995-4.996l-1.14-1.9-0.679-1.14-2.095-3.485-3.913 6.525c-1.229 2.045-2.951 3.767-4.996 4.996l-1.9 1.14-1.925 1.156h-2.425l6.136-34.765h-9.702l-6.136 34.765h-10.616l-3.38 19.195c-0.687 3.864-4.034 6.678-7.963 6.678v3.234h45.955v-3.234h-8.909c1.633-1.609 2.797-3.719 3.226-6.121l1.835-10.413c0.282 0.38 0.55 0.776 0.8 1.188l3.913 6.525 2.095-3.485 0.679-1.14 1.14-1.9c1.229-2.045 2.951-3.767 4.995-4.996l6.526-3.913-4.625-2.774"
            fill="#3395FE"
          />
          <path
            d="m44.513 61.484h-4.713c1.633-1.609 2.797-3.719 3.226-6.121l1.835-10.413c0.282 0.38 0.55 0.776 0.8 1.188l3.574 5.959-0.526 2.983c-0.477 2.701-2.037 4.973-4.196 6.404m-12.637 0h-11.675c1.27-1.512 2.143-3.55 2.596-6.121l0.776-4.39h-3.267l1.003-5.659h8.214l-1.706 9.702h3.234l1.706-9.702h8.757l-1.674 9.492c-0.687 3.864-4.034 6.678-7.964 6.678m-14.618-1.609c0.768-0.865 1.391-1.868 1.819-2.984-0.42 1.27-1.026 2.256-1.819 2.984"
            fill="#C1DFFE"
          />
          <path
            d="m39.153 63.101h-29.123c2.83 0 5.417-1.221 7.212-3.21l0.016-0.016c0.793-0.728 1.399-1.714 1.819-2.984 0.227-0.574 0.396-1.18 0.51-1.811l0.719-4.107h3.267l-0.776 4.39c-0.453 2.571-1.326 4.609-2.596 6.121h11.675c3.93 0 7.277-2.814 7.964-6.678l1.674-9.492h-8.757l-1.706 9.702h-3.234l1.706-9.702h-8.214l0.566-3.234h24.829c0.388 0.452 0.752 0.929 1.099 1.423 0.219 0.315 0.429 0.638 0.631 0.97l1.14 1.9 0.195-0.332 0.751-1.245-1.285 7.301-3.574-5.959c-0.25-0.412-0.518-0.808-0.8-1.188l-1.835 10.413c-0.429 2.402-1.593 4.512-3.226 6.121h4.713c-1.544 1.027-3.396 1.617-5.36 1.617"
            fill="#3395FE"
          />
        </svg>
      )

    case 'OTHER':
      return (
        <svg viewBox="0 0 56 62">
          <path
            d="m11.83 19.441h3.234v-4.851h4.851v-3.234h-4.851v-4.851h-3.234v4.851h-4.851v3.234h4.851v4.851"
            fill="#3395FE"
          />
          <path d="m23.149 35.611h19.404v-3.234h-19.404z" fill="#3395FE" />
          <path d="m16.681 35.611h3.234v-3.234h-3.234z" fill="#3395FE" />
          <path d="m23.149 42.08h19.404v-3.234h-19.404z" fill="#3395FE" />
          <path d="m16.681 42.08h3.234v-3.234h-3.234z" fill="#3395FE" />
          <path d="m23.149 48.548h19.404v-3.234h-19.404z" fill="#3395FE" />
          <path d="m16.681 48.548h3.234v-3.234h-3.234z" fill="#3395FE" />
          <path
            d="m49.021 55.016h-38.808v-29.107h16.17v-11.319h22.638v40.426m-42.042-32.341h-3.234v-19.404h19.404v19.404h-16.17m42.042-11.319h-22.638v-11.319h-25.872v25.872h6.468v32.341h45.276v-46.894h-3.234"
            fill="#3395FE"
          />
          <path
            d="m29.617 29.143h-19.404v-3.234h16.17v-11.319h3.234v14.553zm-25.872 0h3.234v-3.234h-3.234v3.234zm22.638-17.787h3.234v-8.085h-3.234v8.085z"
            fill="#C1DFFE"
          />
          <path
            d="m6.979 29.143h3.234v-3.234h-3.234v3.234zm19.404-14.553h3.234v-3.234h-3.234v3.234z"
            fill="#3395FE"
          />
          <path
            d="m55.489 61.484h-45.276v-3.234h42.042v-43.66h3.234v46.894"
            fill="#C1DFFE"
          />
        </svg>
      )

    case 'NEXT_ARROW':
      return (
        <svg viewBox="0 0 19 14" width={19} height={14}>
          <g opacity="1">
            <path
              d="m5.222 4.476h11.579l-2.434-2.754c-0.158-0.179-0.143-0.453 0.034-0.612s0.449-0.144 0.607 0.035l2.742 3.102c0.334 0.378 0.333 0.948-1e-3 1.326l-2.741 3.102c-0.085 0.096-0.203 0.145-0.321 0.145-0.102 0-0.204-0.037-0.286-0.11-0.177-0.16-0.192-0.434-0.034-0.612l2.434-2.755h-11.579c-1.854 0-3.363 1.523-3.363 3.395s1.509 3.395 3.363 3.395h2.045c0.237 0 0.429 0.194 0.429 0.434 0 0.239-0.192 0.433-0.429 0.433h-2.045c-2.328 0-4.222-1.912-4.222-4.262s1.894-4.262 4.222-4.262"
              fill="#EFF0F3"
            />
            <path
              d="m5.222 4.476h11.579l-2.434-2.754c-0.158-0.179-0.143-0.453 0.034-0.612s0.449-0.144 0.607 0.035l2.742 3.102c0.334 0.378 0.333 0.948-1e-3 1.326l-2.741 3.102c-0.085 0.096-0.203 0.145-0.321 0.145-0.102 0-0.204-0.037-0.286-0.11-0.177-0.16-0.192-0.434-0.034-0.612l2.434-2.755h-11.579c-1.854 0-3.363 1.523-3.363 3.395s1.509 3.395 3.363 3.395h2.045c0.237 0 0.429 0.194 0.429 0.434 0 0.239-0.192 0.433-0.429 0.433h-2.045c-2.328 0-4.222-1.912-4.222-4.262s1.894-4.262 4.222-4.262"
              fillOpacity="0"
              stroke="#EFF0F3"
              strokeWidth="1.5"
            />
          </g>
        </svg>
      )

    case 'BACK_ARROW':
      return (
        <svg viewBox="0 0 19 14" width={19} height={14}>
          <g opacity="1">
            <path
              d="m13.778 4.476h-11.579l2.434-2.754c0.158-0.179 0.143-0.453-0.034-0.612s-0.449-0.144-0.607 0.035l-2.742 3.102c-0.334 0.378-0.333 0.948 1e-3 1.326l2.741 3.102c0.085 0.096 0.203 0.145 0.321 0.145 0.102 0 0.204-0.037 0.286-0.11 0.177-0.16 0.192-0.434 0.034-0.612l-2.434-2.755h11.579c1.854 0 3.363 1.523 3.363 3.395s-1.509 3.395-3.363 3.395h-2.045c-0.237 0-0.429 0.194-0.429 0.434 0 0.239 0.192 0.433 0.429 0.433h2.045c2.328 0 4.222-1.912 4.222-4.262s-1.894-4.262-4.222-4.262"
              fill="#EFF0F3"
            />
            <path
              d="m13.778 4.476h-11.579l2.434-2.754c0.158-0.179 0.143-0.453-0.034-0.612s-0.449-0.144-0.607 0.035l-2.742 3.102c-0.334 0.378-0.333 0.948 1e-3 1.326l2.741 3.102c0.085 0.096 0.203 0.145 0.321 0.145 0.102 0 0.204-0.037 0.286-0.11 0.177-0.16 0.192-0.434 0.034-0.612l-2.434-2.755h11.579c1.854 0 3.363 1.523 3.363 3.395s-1.509 3.395-3.363 3.395h-2.045c-0.237 0-0.429 0.194-0.429 0.434 0 0.239 0.192 0.433 0.429 0.433h2.045c2.328 0 4.222-1.912 4.222-4.262s-1.894-4.262-4.222-4.262"
              fillOpacity="0"
              stroke="#EFF0F3"
              strokeWidth="1.5"
            />
          </g>
        </svg>
      )
    case 'LOCATE_MAP':
      return (
        <svg viewBox="0 0 12 17" width={12} height={17}>
          <path
            d="m11.361 4.204c-0.06-0.225-0.182-0.465-0.273-0.676-1.08-2.597-3.442-3.528-5.349-3.528-2.552 0-5.363 1.712-5.739 5.24v0.72c0 0.03 0.01 0.301 0.025 0.436 0.211 1.681 1.537 3.468 2.528 5.15 1.066 1.801 2.172 3.573 3.268 5.345 0.676-1.157 1.35-2.328 2.01-3.454 0.18-0.33 0.389-0.66 0.569-0.975 0.12-0.211 0.35-0.421 0.454-0.616 1.066-1.952 2.782-3.918 2.782-5.856v-0.795c0-0.21-0.26-0.946-0.275-0.991zm-5.575 3.618c-0.75 0-1.572-0.375-1.977-1.411-0.06-0.165-0.055-0.496-0.055-0.526v-0.466c0-1.32 1.121-1.921 2.097-1.921 1.201 0 2.13 0.961 2.13 2.163 0 1.201-0.994 2.161-2.195 2.161z"
            fill="#FFFFFF"
          />
        </svg>
      )

    case 'CHECK':
      return (
        <svg viewBox="0 0 18 14" width={18} height={14}>
          <path
            d="M2,6.3 L7.083,12 L16,2"
            fillOpacity="0"
            stroke={color || '#FFF'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="3"
          />
        </svg>
      )

    case 'SEARCH':
      return (
        <svg viewBox="0 0 16 17" width={width || 16} height={height || 17}>
          <path
            d="m15.794 15.697l-3.735-3.874c1.203-1.303 1.87-3.012 1.868-4.785-0.04-3.915-3.15-7.06-6.957-7.038-3.813-0.03-6.93 3.118-6.97 7.038 0.04 3.92 3.157 7.068 6.97 7.038 1.409 1e-3 2.785-0.431 3.941-1.238l3.792 3.94c0.141 0.142 0.333 0.222 0.534 0.222 0.2 0 0.392-0.08 0.533-0.222 0.296-0.295 0.307-0.772 0.024-1.08zm-14.27-8.659c0.035-3.06 2.47-5.513 5.446-5.488 2.975-0.024 5.408 2.43 5.444 5.488-0.036 3.058-2.47 5.512-5.444 5.488-2.976 0.025-5.411-2.428-5.446-5.488z"
            fill={color || '#FFF'}
          />
        </svg>
      )

    case 'MENU':
      return (
        <svg viewBox="0 0 20 19" width={width || 20} height={height || 19}>
          <path
            d="m18.426 1h-16.728c-0.389 4e-3 -0.701 0.323-0.698 0.712 0 0.392 0.313 0.708 0.698 0.708h16.728c0.388-3e-3 0.701-0.32 0.698-0.708 3e-3 -0.389-0.309-0.708-0.698-0.712zm0 8h-16.728c-0.187 1e-3 -0.365 0.076-0.496 0.209s-0.204 0.312-0.202 0.499c0 0.393 0.313 0.712 0.698 0.712h16.728c0.385 0 0.698-0.32 0.698-0.712 3e-3 -0.388-0.31-0.705-0.698-0.708zm0 8h-16.728c-0.389 4e-3 -0.701 0.323-0.698 0.712 0 0.393 0.313 0.713 0.698 0.713h16.728c0.385 0 0.698-0.32 0.698-0.713 3e-3 -0.389-0.309-0.707-0.698-0.712z"
            fill="#fff"
          />
          <path
            d="m18.426 1h-16.728c-0.389 4e-3 -0.701 0.323-0.698 0.712 0 0.392 0.313 0.708 0.698 0.708h16.728c0.388-3e-3 0.701-0.32 0.698-0.708 3e-3 -0.389-0.309-0.708-0.698-0.712zm0 8h-16.728c-0.187 1e-3 -0.365 0.076-0.496 0.209s-0.204 0.312-0.202 0.499c0 0.393 0.313 0.712 0.698 0.712h16.728c0.385 0 0.698-0.32 0.698-0.712 3e-3 -0.388-0.31-0.705-0.698-0.708zm0 8h-16.728c-0.389 4e-3 -0.701 0.323-0.698 0.712 0 0.393 0.313 0.713 0.698 0.713h16.728c0.385 0 0.698-0.32 0.698-0.713 3e-3 -0.389-0.309-0.707-0.698-0.712z"
            fillOpacity="0"
            stroke="#fff"
            strokeWidth=".5"
          />
        </svg>
      )

    case 'HOME':
      return (
        <svg viewBox="0 0 26 24" width={width || 26} height={height || 24}>
          <path
            fill="#000000"
            fillRule="evenOdd"
            d="M.898 14.292h2.118v8.768c0 .517.408.94.908.94h6.202c.499 0 .907-.423.907-.94v-6.42h3.782v6.42c0 .517.408.94.908.94h5.9c.498 0 .907-.423.907-.94v-8.768H25.1a.908.908 0 0 0 .832-.58.968.968 0 0 0-.196-1.017L13.907.278a.882.882 0 0 0-1.27-.015L.277 12.679a.963.963 0 0 0-.21 1.034c.135.36.468.579.831.579zM13.242 2.267l9.681 10.146h-1.3c-.5 0-.909.423-.909.94v8.768H16.63v-6.42c0-.517-.408-.94-.907-.94h-5.597c-.5 0-.908.423-.908.94v6.42H4.831v-8.768c0-.517-.408-.94-.907-.94h-.787L13.242 2.267z"
          />
        </svg>
      )

    case 'MY_LOCATION':
      return (
        <svg viewBox="0 0 24 24" width={width || 24} height={height || 24}>
          <path
            fill={color || '#FFF'}
            fillRule="evenOdd"
            d="M12 7.304A4.705 4.705 0 0 0 7.304 12c0 2.58 2.11 4.696 4.696 4.696 2.58 0 4.696-2.116 4.696-4.696A4.708 4.708 0 0 0 12 7.304zm9.71 3.604c-.549-4.58-4.15-8.181-8.618-8.617V0h-2.184v2.29a9.547 9.547 0 0 0-8.617 8.618H0v2.184h2.29c.543 4.58 4.144 8.181 8.618 8.617V24h2.184v-2.29c4.58-.549 8.181-4.15 8.617-8.618H24v-2.184h-2.29zm-9.707 8.918c-4.362 0-7.83-3.46-7.83-7.823a7.782 7.782 0 0 1 7.83-7.83c4.363 0 7.823 3.468 7.823 7.83a7.77 7.77 0 0 1-7.823 7.823z"
          />
        </svg>
      )
    case 'DEPARTMENT_LIST':
      return (
        <svg
          viewBox="0 0 24 24"
          width={width || 24}
          height={height || 24}
          onClick={onClick}
        >
          <g fill="#3395FE">
            <path d="m1.44 14.058c-0.76 0-1.44 0.652-1.44 1.425 0 0.774 0.68 1.466 1.44 1.466s1.4-0.692 1.4-1.466c0-0.773-0.64-1.425-1.4-1.425zm0-7.004c-0.76 0-1.44 0.652-1.44 1.426 0 0.773 0.68 1.425 1.44 1.425s1.4-0.652 1.4-1.425c0-0.774-0.64-1.426-1.4-1.426zm5.12-4.275h12.12c0.72 0 1.32-0.57 1.32-1.303s-0.6-1.344-1.32-1.344h-12.12c-0.72 0-1.32 0.611-1.32 1.344s0.6 1.303 1.32 1.303zm-5.12-2.769c-0.76 0-1.44 0.692-1.44 1.466s0.68 1.425 1.44 1.425 1.4-0.651 1.4-1.425-0.64-1.466-1.4-1.466z" />
            <path d="m18.659 7h-12.319c-0.73 0-1.34 0.682-1.34 1.5s0.61 1.5 1.341 1.5h12.319c0.73 0 1.34-0.682 1.34-1.5s-0.61-1.5-1.341-1.5zm0 7h-12.319c-0.73 0-1.34 0.682-1.34 1.5s0.61 1.5 1.341 1.5h12.319c0.73 0 1.34-0.682 1.34-1.5s-0.61-1.5-1.341-1.5z" />
          </g>
        </svg>
      )
    case 'DELETE_BOOKING':
      return (
        <svg width="34" height="34" viewBox="0 0 34 34">
          <g fill="none" fillRule="evenOdd">
            <circle cx="17" cy="17" r="17" fill="#A4A9B7" />
            <g
              stroke="#FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.62"
            >
              <path d="M11.249 11.233l11.443 11.443M22.692 11.233L11.25 22.676" />
            </g>
          </g>
        </svg>
      )
    case 'DELETE_ATTENDEE':
      return (
        <svg width={width || 43} height={height || 34} viewBox="0 0 34 34">
          <g fill="none" fillRule="evenOdd">
            <circle cx="17" cy="17" r="17" fill="#A4A9B7" />
            <g
              stroke="#FFF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.62"
            >
              <path d="M11.249 11.233l11.443 11.443M22.692 11.233L11.25 22.676" />
            </g>
          </g>
        </svg>
      )

    case 'CALENDAR':
      return (
        <svg viewBox="0 0 14 14" width="20" height="20">
          <path
            d="m13.612 2.416c-0.203-0.193-0.473-0.298-0.753-0.294h-1.072v-0.742c0-0.34-0.13-0.632-0.393-0.874-0.256-0.24-0.595-0.37-0.946-0.364h-0.536c-0.368 0-0.683 0.122-0.946 0.364-0.252 0.22-0.396 0.539-0.394 0.874v0.742h-3.214v-0.742c0-0.34-0.131-0.632-0.394-0.874-0.256-0.24-0.595-0.37-0.946-0.364h-0.536c-0.368 0-0.683 0.122-0.945 0.364-0.253 0.22-0.396 0.539-0.394 0.874v0.742h-1.071c-0.29 0-0.542 0.098-0.754 0.294-0.202 0.174-0.319 0.429-0.318 0.696v9.899c0 0.267 0.106 0.5 0.318 0.695 0.212 0.196 0.463 0.294 0.754 0.294h11.787c0.29 0 0.541-0.098 0.753-0.294 0.202-0.174 0.318-0.428 0.318-0.695v-9.899c0-0.268-0.106-0.5-0.318-0.696zm-3.968-1.036c0-0.073 0.025-0.132 0.075-0.178 0.053-0.048 0.122-0.073 0.193-0.07h0.536c0.078 0 0.142 0.023 0.193 0.07 0.05 0.046 0.075 0.105 0.075 0.178v2.227c2e-3 0.067-0.025 0.132-0.075 0.178-0.053 0.047-0.122 0.073-0.193 0.07h-0.536c-0.071 3e-3 -0.14-0.022-0.193-0.07-0.05-0.046-0.077-0.111-0.075-0.178v-2.227zm-6.429 0c0-0.073 0.025-0.132 0.075-0.178 0.052-0.047 0.121-0.073 0.192-0.07h0.536c0.079 0 0.143 0.023 0.193 0.07 0.05 0.046 0.075 0.105 0.075 0.178v2.227c2e-3 0.067-0.025 0.132-0.075 0.178-0.053 0.048-0.122 0.073-0.193 0.07h-0.536c-0.071 2e-3 -0.139-0.023-0.192-0.07-0.05-0.046-0.077-0.111-0.075-0.178v-2.227zm-2.143 11.63h11.787v-7.919h-11.787v7.919z"
            fill="#3395FE"
          />
          <path d="m0.875 4.25h12.078v8.766h-12.078v-8.766z" fill="#fff" />
          <path
            d="m0.875 4.25h12.078v8.766h-12.078v-8.766z"
            fillOpacity="0"
            stroke="#4E95F6"
          />
        </svg>
      )

    case 'CLOCK':
      return (
        <svg viewBox="0 0 14 14" width="20" height="20">
          <g fill="#3395FE">
            <path d="m7 0c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm0 12.51c-3.041-4e-3 -5.506-2.469-5.51-5.51 4e-3 -3.041 2.469-5.506 5.51-5.51 3.041 4e-3 5.506 2.469 5.51 5.51-4e-3 3.041-2.469 5.506-5.51 5.51z" />
            <path d="m10.408 5.954h-3.226v-3.431c0-0.289-0.264-0.523-0.591-0.523-0.326 0-0.591 0.234-0.591 0.523v3.954c0 0.29 0.265 0.523 0.591 0.523h3.817c0.327 0 0.592-0.234 0.592-0.523 0-0.288-0.265-0.523-0.592-0.523z" />
          </g>
        </svg>
      )

    case 'LIST':
      return (
        <svg viewBox="0 0 20 17" width="20" height="20">
          <g fill="#3395FE">
            <path d="m1.44 14.058c-0.76 0-1.44 0.652-1.44 1.425 0 0.774 0.68 1.466 1.44 1.466s1.4-0.692 1.4-1.466c0-0.773-0.64-1.425-1.4-1.425zm0-7.004c-0.76 0-1.44 0.652-1.44 1.426 0 0.773 0.68 1.425 1.44 1.425s1.4-0.652 1.4-1.425c0-0.774-0.64-1.426-1.4-1.426zm5.12-4.275h12.12c0.72 0 1.32-0.57 1.32-1.303s-0.6-1.344-1.32-1.344h-12.12c-0.72 0-1.32 0.611-1.32 1.344s0.6 1.303 1.32 1.303zm-5.12-2.769c-0.76 0-1.44 0.692-1.44 1.466s0.68 1.425 1.44 1.425 1.4-0.651 1.4-1.425-0.64-1.466-1.4-1.466z" />
            <path d="m18.659 7h-12.319c-0.73 0-1.34 0.682-1.34 1.5s0.61 1.5 1.341 1.5h12.319c0.73 0 1.34-0.682 1.34-1.5s-0.61-1.5-1.341-1.5zm0 7h-12.319c-0.73 0-1.34 0.682-1.34 1.5s0.61 1.5 1.341 1.5h12.319c0.73 0 1.34-0.682 1.34-1.5s-0.61-1.5-1.341-1.5z" />
          </g>
        </svg>
      )

    case 'FLOOR_PLAN':
      return (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path
            fill="#3395FE"
            fillRule="evenOdd"
            stroke="#3395FE"
            d="M22.558 1H1.442A.442.442 0 0 0 1 1.442v21.116c0 .244.198.442.442.442h12.879a.442.442 0 0 0 0-.884H1.884V11.813H8.05v4.238a.442.442 0 0 0 .884 0V6.795a.442.442 0 0 0-.884 0v4.134H1.884V1.884H13.88V7.42c0 .244.198.442.442.442h4.675a.442.442 0 1 0 0-.884h-4.233V1.884h7.353V15.61h-7.795a.442.442 0 0 0 0 .884h7.795v5.623h-3.12a.442.442 0 1 0 0 .884h3.562a.442.442 0 0 0 .442-.442V1.442A.442.442 0 0 0 22.558 1z"
          />
        </svg>
      )

    case 'RECURRENCE':
      return (
        <svg viewBox="0 0 13 14" width="13" height="14">
          <path
            d="m1.119 5.84c0.446 0 0.85-0.268 1.022-0.682 0.713-1.708 2.389-2.91 4.343-2.91 1.077 0 2.064 0.37 2.856 0.986l-0.62 0.096c-0.19-0.086-0.413-0.041-0.555 0.111-0.143 0.152-0.173 0.377-0.075 0.561 0.097 0.184 0.3 0.286 0.506 0.253l3.41 1.543c0.15 0.068 0.324 0.055 0.462-0.034 0.139-0.09 0.222-0.243 0.221-0.408l0.018-3.779c0.113-0.172 0.104-0.396-0.021-0.559s-0.34-0.229-0.535-0.164-0.328 0.246-0.331 0.451l-0.47 0.71c-1.293-1.286-3.043-2.007-4.866-2.006-2.874-1e-3 -5.342 1.761-6.396 4.269-0.146 0.347-0.109 0.744 0.098 1.059 0.207 0.314 0.557 0.504 0.933 0.504zm11.662 2.795c-0.224-0.346-0.622-0.538-1.032-0.5-0.41 0.037-0.766 0.299-0.923 0.68-0.712 1.707-2.388 2.91-4.342 2.91-1.036-1e-3 -2.041-0.348-2.856-0.987l0.62-0.096c0.19 0.086 0.413 0.041 0.555-0.111 0.143-0.152 0.173-0.377 0.075-0.561-0.097-0.184-0.3-0.286-0.506-0.253l-3.41-1.543c-0.15-0.068-0.324-0.055-0.462 0.034s-0.221 0.243-0.221 0.407l-0.018 3.78c-0.113 0.172-0.104 0.396 0.021 0.559s0.34 0.229 0.535 0.164 0.328-0.246 0.331-0.451l0.47-0.71c1.293 1.286 3.043 2.008 4.867 2.007 2.872 0 5.342-1.763 6.395-4.27 0.146-0.348 0.109-0.745-0.098-1.06z"
            fill="#3395FE"
          />
        </svg>
      )

    case 'CAMPUS':
      return (
        <svg viewBox="0 0 25 25" width="25" height="25">
          <path
            d="m18.75 15.625h3.125v-3.125h-3.125v3.125zm-2.344-11.719c0 0.583-0.128 1.137-0.357 1.633l-3.549 6.961-3.55-6.961c-0.666-1.452-0.381-3.163 0.719-4.32 1.1-1.158 2.795-1.529 4.278-0.937 1.484 0.591 2.457 2.027 2.459 3.624zm-1.562 0c0-1.295-1.05-2.344-2.345-2.344s-2.344 1.05-2.344 2.345 1.05 2.345 2.345 2.345c1.294 0 2.344-1.05 2.344-2.345zm10.156 2.344v15.625c0 1.725-1.4 3.125-3.125 3.125h-18.75c-1.726 0-3.125-1.399-3.125-3.125v-15.625c0-1.726 1.4-3.125 3.125-3.125h3.985c-0.037 0.256-0.08 0.513-0.08 0.781 0 0.264 0.049 0.522 0.086 0.782h-0.866v4.687h2.902l0.797 1.562h-3.7v6.25h9.376v-6.25h-0.575l2.138-4.193v2.631h6.25v-3.125c0-0.862-0.701-1.562-1.563-1.562h-3.99c0.038-0.26 0.084-0.516 0.084-0.782 0-0.268-0.041-0.525-0.08-0.781h3.986c1.725 0 3.125 1.4 3.125 3.125zm-20.312 12.5h-3.125v3.125c0 0.862 0.702 1.562 1.562 1.562h1.563v-4.687zm-3.125-1.562h3.125v-6.25h-3.125v6.25zm3.125-12.5h-1.563c-0.86 0-1.562 0.7-1.562 1.562v3.125h3.125v-4.687zm1.562 18.75h9.375v-4.688h-9.375v4.687zm17.187-4.688h-6.25v4.687h4.688c0.862 0 1.562-0.7 1.562-1.562v-3.125zm-6.25-1.562h6.25v-6.25h-6.25v6.25z"
            fill="#fff"
          />
        </svg>
      )

    case 'MORE':
      return (
        <svg viewBox="0 0 31 31" width="31" height="31">
          <path
            d="m30 15.5c0 8.008-6.492 14.5-14.5 14.5s-14.5-6.492-14.5-14.5 6.492-14.5 14.5-14.5 14.5 6.492 14.5 14.5z"
            fillOpacity="0"
            stroke="#A4A9B7"
            strokeWidth=".5"
          />
          <g fill="#ABB0BE">
            <path d="m11.5 15.5c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1z" />
            <path d="m16.5 15.5c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1z" />
            <path d="m21.5 15.5c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1z" />
          </g>
        </svg>
      )

    case 'EDIT':
      return (
        <svg viewBox="0 0 23 23" width="23" height="23">
          <path
            d="m18.168 8.192l-3.354-3.36 2.723-2.717 3.348 3.348-2.717 2.729zm-10.888 10.904l-3.375-3.376 10.117-10.1 3.359 3.359-10.1 10.117zm-5.385 2.008l1.457-4.352 2.896 2.896-4.353 1.456zm16.033-20.172c-0.104-0.104-0.246-0.163-0.393-0.163-0.148 0-0.29 0.059-0.394 0.163l-14.391 14.364c-0.076 0.066-0.134 0.15-0.167 0.245l-2.099 6.266c-0.1 0.29 0.062 0.609 0.352 0.71 0.117 0.038 0.24 0.038 0.351 0l6.273-2.099c0.095-0.033 0.179-0.091 0.245-0.167l10.859-10.882 3.504-3.515c0.104-0.104 0.163-0.246 0.163-0.394 0-0.147-0.059-0.289-0.163-0.393l-4.14-4.135z"
            fill="#fff"
          />
          <path
            d="m18.168 8.192l-3.354-3.36 2.723-2.717 3.348 3.348-2.717 2.729zm-10.888 10.904l-3.375-3.376 10.117-10.1 3.359 3.359-10.1 10.117zm-5.385 2.008l1.457-4.352 2.896 2.896-4.353 1.456zm16.033-20.172c-0.104-0.104-0.246-0.163-0.393-0.163-0.148 0-0.29 0.059-0.394 0.163l-14.391 14.364c-0.076 0.066-0.134 0.15-0.167 0.245l-2.099 6.266c-0.1 0.29 0.062 0.609 0.352 0.71 0.117 0.038 0.24 0.038 0.351 0l6.273-2.099c0.095-0.033 0.179-0.091 0.245-0.167l10.859-10.882 3.504-3.515c0.104-0.104 0.163-0.246 0.163-0.394 0-0.147-0.059-0.289-0.163-0.393l-4.14-4.135z"
            fillOpacity="0"
            stroke="#fff"
            strokeWidth=".748"
          />
        </svg>
      )

    case 'ADD_ATTENDEE':
      return (
        <svg viewBox="0 0 38 38" width={width || 38} height={width || 38}>
          <path
            d="m36.58 19c0 9.803-7.909 17.75-17.665 17.75s-17.665-7.947-17.665-17.75 7.909-17.75 17.665-17.75 17.665 7.947 17.665 17.75z"
            fillOpacity="0"
            stroke="#A3CBF7"
            strokeWidth="2.5"
          />
          <path
            d="m17.48 20.34h-4.036c-0.552 0-1-0.448-1-1v-0.589c0-0.552 0.448-1 1-1h4.035v-4.251c0-0.552 0.448-1 1-1h0.85c0.552 0 1 0.448 1 1v4.251h4.035c0.552 0 1 0.448 1 1v0.589c0 0.552-0.448 1-1 1h-4.035v4.433c0 0.552-0.448 1-1 1h-0.85c-0.552 0-1-0.448-1-1v-4.433z"
            fill="#A3CBF7"
          />
        </svg>
      )

    case 'CLOSE':
      return (
        <svg viewBox="0 0 24 24" width={width || 24} height={height || 24}>
          <g
            fillOpacity="0"
            stroke="#9C9DA4"
            strokeLinecap="round"
            strokeWidth="3"
          >
            <path d="m2.436 2.408l19.41 19.41" />
            <path
              d="m21.845 2.408l-19.41 19.41 19.41-19.41z"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      )

    case 'SUCCESS':
      return (
        <svg width="31" height="31" viewBox="0 0 31 31">
          <g fill="none" transform="translate(-1)">
            <mask id="b" fill="#fff">
              <path d="M0 0h32v32H0z" />
            </mask>
            <path
              fill="#3395FE"
              d="M10.005 12.75a1.166 1.166 0 0 0-1.63-.077 1.148 1.148 0 0 0-.078 1.62l5.86 6.321c.233.232.505.386.815.386h.04c.31 0 .62-.116.814-.347L30.651 5.966c.465-.463.465-1.195 0-1.62-.466-.462-1.203-.462-1.63 0L15.05 18.187l-5.045-5.435"
              mask="url(#b)"
            />
            <path
              fill="#3395FE"
              d="M30.832 14.332c-.662 0-1.169.506-1.169 1.168 0 7.244-5.92 13.163-13.163 13.163-7.244 0-13.163-5.92-13.163-13.163 0-7.244 5.92-13.163 13.163-13.163.662 0 1.168-.507 1.168-1.169S17.162 0 16.5 0C7.971 0 1 6.971 1 15.5S7.971 31 16.5 31 32 24.029 32 15.5c0-.662-.506-1.168-1.168-1.168"
              mask="url(#b)"
            />
          </g>
        </svg>
      )

    case 'PLUS_CIRCLE':
      return (
        <svg width="60" height="60" viewBox="0 0 60 60">
          <defs>
            <filter
              id="a"
              width="139.6%"
              height="139.6%"
              x="-19.8%"
              y="-17.7%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
                stdDeviation="3"
              />
              <feColorMatrix
                in="shadowBlurOuter1"
                values="0 0 0 0 0.2 0 0 0 0 0.584313725 0 0 0 0 0.996078431 0 0 0 0.38 0"
              />
            </filter>
          </defs>
          <g fill="none">
            <g transform="translate(6 5)">
              <circle cx="24" cy="24" r="24" fill="#000" filter="url(#a)" />
              <circle cx="24" cy="24" r="24" fill="#FFF" />
            </g>
            <path
              fill="#006ee5"
              d="M31.497 27.56H40.5v2.922h-9.003V39.5h-3.038v-9.018H19.5V27.56h8.96V18.5h3.037z"
            />
          </g>
        </svg>
      )

    case 'BUILDING':
      return (
        <svg viewBox="0 0 96 96" width={width || 96} height={height || 96}>
          <path d="m54.3 50.7h10.8v25.2h-10.8z" opacity=".3" />
          <path d="m32.7 39.9h9v25.2h-9z" opacity=".3" />
          <path d="m56.1 25.5h5.4v12.6h-5.4z" opacity=".3" />
          <path d="m50.7 16.5h3.6v19.8h-3.6z" opacity=".3" />
          <path d="m32.7 65.1h9v16.2h-9z" opacity=".3" />
          <path d="m18.3 66.9h7.2v16.2h-7.2z" opacity=".3" />
          <path d="m50.7 75.9h3.6v3.6h-3.6z" opacity=".3" />
          <path d="m47.1 68.7h3.6v3.6h-3.6z" fill="#fff" />
          <path d="m47.1 61.5h3.6v3.6h-3.6z" fill="#fff" />
          <path d="m47.1 54.3h3.6v3.6h-3.6z" fill="#fff" />
          <path d="m47.1 47.1h3.6v3.6h-3.6z" fill="#fff" />
          <path
            d="m72.3 47.1v-23.4h-14.4v-10.8h-3.6v23.4h-14.4v27h-14.4v19.8h52.2v-36zm-14.4-19.8h10.8v9h-10.8zm-18 52.2h-10.8v-12.6h10.8zm3.6 0v-39.6h25.2v7.2h-5.4v28.8h-9v3.6zm30.6 0h-7.2v-7.2h7.2zm0-10.8h-7.2v-3.6h7.2zm0-7.2h-7.2v-10.8h7.2z"
            fill="#fff"
          />
        </svg>
      )

    case 'MEETINGS':
      return (
        <svg viewBox="0 0 45 45" width={width || 45} height={height || 45}>
          <path
            fill="#3395fe"
            d="M 35.773438 45 C 40.859375 45 45 40.820312 45 35.683594 C 45 32.007812 42.839844 28.832031 39.726562 27.347656 C 39.726562 23.816406 39.726562 6.160156 39.726562 2.636719 L 31.816406 2.636719 L 31.816406 0 L 29.179688 0 L 29.179688 2.636719 L 21.179688 2.636719 L 21.179688 0 L 18.546875 0 L 18.546875 2.636719 L 10.632812 2.636719 L 10.632812 0 L 8 0 L 8 2.636719 L 0 2.636719 L 0 39.640625 L 27.417969 39.640625 C 28.894531 42.804688 32.082031 45 35.769531 45 Z M 42.363281 35.683594 C 42.363281 39.367188 39.40625 42.363281 35.773438 42.363281 C 32.136719 42.363281 29.179688 39.367188 29.179688 35.683594 C 29.179688 32.050781 32.136719 29.09375 35.773438 29.09375 C 39.40625 29.09375 42.363281 32.050781 42.363281 35.683594 Z M 2.636719 5.273438 L 8 5.273438 L 8 7.910156 L 10.632812 7.910156 L 10.632812 5.273438 L 18.546875 5.273438 L 18.546875 7.910156 L 21.179688 7.910156 L 21.179688 5.273438 L 29.179688 5.273438 L 29.179688 7.910156 L 31.816406 7.910156 L 31.816406 5.273438 L 37.089844 5.273438 L 37.089844 10.546875 L 2.636719 10.546875 Z M 2.636719 37 L 2.636719 13.183594 L 37.089844 13.183594 L 37.089844 26.550781 C 36.660156 26.488281 36.21875 26.453125 35.773438 26.453125 C 30.683594 26.453125 26.542969 30.59375 26.542969 35.683594 C 26.542969 36.132812 26.574219 36.570312 26.636719 37 Z M 2.636719 37 "
          />
          <path
            fill="#3395fe"
            d="M 34.453125 31.726562 L 34.453125 37 L 39.726562 37 L 39.726562 34.367188 L 37.089844 34.367188 L 37.089844 31.726562 Z M 34.453125 31.726562 "
          />
          <path
            fill="#3395fe"
            d="M 5.359375 23.820312 L 13.273438 23.820312 L 13.273438 15.90625 L 5.359375 15.90625 Z M 8 18.546875 L 10.632812 18.546875 L 10.632812 21.179688 L 8 21.179688 Z M 8 18.546875 "
          />
          <path
            fill="#3395fe"
            d="M 5.359375 34.367188 L 13.273438 34.367188 L 13.273438 26.453125 L 5.359375 26.453125 Z M 8 29.09375 L 10.632812 29.09375 L 10.632812 31.726562 L 8 31.726562 Z M 8 29.09375 "
          />
          <path
            fill="#3395fe"
            d="M 15.90625 34.367188 L 23.820312 34.367188 L 23.820312 26.453125 L 15.90625 26.453125 Z M 18.546875 29.09375 L 21.179688 29.09375 L 21.179688 31.726562 L 18.546875 31.726562 Z M 18.546875 29.09375 "
          />
          <path
            fill="#3395fe"
            d="M 15.90625 23.820312 L 23.820312 23.820312 L 23.820312 15.90625 L 15.90625 15.90625 Z M 18.546875 18.546875 L 21.179688 18.546875 L 21.179688 21.179688 L 18.546875 21.179688 Z M 18.546875 18.546875 "
          />
          <path
            fill="#3395fe"
            d="M 34.453125 15.90625 L 26.542969 15.90625 L 26.542969 23.820312 L 34.453125 23.820312 Z M 31.816406 21.179688 L 29.179688 21.179688 L 29.179688 18.546875 L 31.816406 18.546875 Z M 31.816406 21.179688 "
          />
        </svg>
      )
    case 'WORKSPACES':
      return (
        <svg viewBox="0 0 45 45" width={width || 45} height={height || 45}>
          <path
            fill="#3395fe"
            d="M 45 17.488281 L 32.683594 17.488281 L 32.683594 10.902344 C 32.683594 6.972656 29.492188 3.78125 25.5625 3.78125 L 19.4375 3.78125 C 15.507812 3.78125 12.316406 6.972656 12.316406 10.902344 L 12.316406 17.488281 L 0 17.488281 L 0 20.125 L 2.640625 20.125 L 2.640625 41.308594 L 10.554688 41.308594 L 10.554688 33.390625 L 21.183594 33.390625 L 21.183594 36.03125 L 13.195312 36.03125 L 13.195312 41.308594 L 15.832031 41.308594 L 15.832031 38.667969 L 21.183594 38.667969 L 21.183594 41.308594 L 23.820312 41.308594 L 23.820312 38.667969 L 29.167969 38.667969 L 29.167969 41.308594 L 31.804688 41.308594 L 31.804688 36.03125 L 23.820312 36.03125 L 23.820312 33.390625 L 34.445312 33.390625 L 34.445312 41.308594 L 42.359375 41.308594 L 42.359375 20.125 L 45 20.125 Z M 14.953125 10.902344 C 14.953125 8.429688 16.964844 6.417969 19.4375 6.417969 L 25.5625 6.417969 C 28.035156 6.417969 30.046875 8.429688 30.046875 10.902344 L 30.046875 17.488281 L 14.953125 17.488281 Z M 39.722656 38.671875 L 37.082031 38.671875 L 37.082031 30.753906 L 7.917969 30.753906 L 7.917969 38.671875 L 5.277344 38.671875 L 5.277344 20.125 L 39.722656 20.125 Z M 39.722656 38.671875 "
          />
        </svg>
      )
    case 'REQUESTS':
      return (
        <svg viewBox="0 0 45 45" width={width || 45} height={height || 45}>
          <path
            fill="#C1DFFE"
            d="M33.234 44.979a4.086 4.086 0 0 1-4.085-4.085V38.85a2.042 2.042 0 1 0 4.085 0V28.214l3.186-3.186a3.027 3.027 0 0 0 .9-2.165v-3.927h4.084v5.97a5.072 5.072 0 0 1-1.496 3.61l-2.589 2.589v4.172h6.128v5.106h-6.128v.51a4.09 4.09 0 0 1-4.085 4.086M4.638 40.383h24v-5.106h-24zM27.106 32.213H6.681v-16.34h5.81l-.188.066 1.226 5.361 4.136-.474c.572 1 1.302 1.914 2.155 2.69l-1.385 3.933 4.954 2.384 1.726-2.762 1.991 1.991v3.15"
          />
          <path
            fill="#3395FE"
            d="M6.68 15.872h2.043V13.83H6.681zM9.745 15.872h2.042V13.83H9.745z"
          />
          <path
            fill="#3395FE"
            d="M35.277 36.298h4.085v-2.043h-4.085v2.043zm-2.043-8.084v10.637a2.042 2.042 0 1 1-4.085 0V28.214l-3.186-3.186a3.027 3.027 0 0 1-.9-2.165v-3.927h2.043v4.504l4.085 4.131 4.086-4.131v-4.504h2.042v3.927c0 .817-.316 1.588-.899 2.165l-3.186 3.186zm-6.128 3.999H4.638V11.787h12.16a10.928 10.928 0 0 0-.559 2.78l-3.934 1.373 1.221 5.359 4.14-.474c.572 1 1.302 1.914 2.152 2.693l-1.383 3.93 4.954 2.384 1.727-2.76 1.99 1.99v3.15zm-24.51 4.085h24.51v-2.043H2.596v2.043zm32.68-4.085v-3.15l2.59-2.59a5.072 5.072 0 0 0 1.496-3.61v-5.97h-6.128v5.71l-2.027 2.052-.016.016-2.042-2.068v-5.71H23.02v5.97c0 .922.248 1.805.704 2.58l-1.098 1.756-1.658-.798 1.249-3.549-.567-.453a9.09 9.09 0 0 1-2.488-3.113l-.316-.652-3.736.428-.409-1.795 3.552-1.239.003-.723a8.957 8.957 0 0 1 .884-3.884l.315-.654-2.663-2.658 1.147-1.438 3.183 2.003.567-.45A8.872 8.872 0 0 1 25.277 6.5l.71-.16.415-3.744h1.84l.415 3.744.71.16a8.876 8.876 0 0 1 3.588 1.725l.567.45 3.182-2.004 1.148 1.438-2.664 2.658.314.654a8.95 8.95 0 0 1 .886 3.884l2.042-.006a10.994 10.994 0 0 0-.79-4.092l2.948-2.944L37.16 3.97l-3.523 2.219c-.959-.666-2-1.167-3.108-1.496L30.07.553h-5.496l-.459 4.14c-1.108.33-2.149.83-3.108 1.496l-3.524-2.22-3.428 4.294 1.485 1.482H2.596v22.468H.553v6.127h26.553v.511a4.086 4.086 0 0 0 4.085 4.085 4.09 4.09 0 0 0 4.086-4.085v-.51h6.127v-6.128h-6.127z"
          />
          <path fill="#3395FE" d="M30.17 38.34h2.043v-2.042H30.17z" />
        </svg>
      )
    case 'MOVE_MY_LOCATION':
      return (
        <svg viewBox="0 0 45 45" width={width || 45} height={height || 45}>
          <path
            fill="#3395fe"
            d="M 35.316406 5.207031 C 29.976562 5.207031 25.628906 9.554688 25.628906 14.894531 C 25.628906 16.457031 26.003906 17.9375 26.664062 19.246094 L 35.316406 37.082031 L 43.964844 19.246094 C 44.628906 17.933594 45 16.457031 45 14.894531 C 45 9.554688 40.65625 5.207031 35.316406 5.207031 Z M 35.316406 22.292969 C 31.234375 22.292969 27.914062 18.972656 27.914062 14.894531 C 27.914062 10.8125 31.234375 7.492188 35.316406 7.492188 C 39.394531 7.492188 42.714844 10.8125 42.714844 14.894531 C 42.714844 18.972656 39.394531 22.292969 35.316406 22.292969 Z M 35.316406 22.292969 "
          />
          <path
            fill="#3395fe"
            d="M 35.316406 8.496094 L 33.445312 12.28125 L 29.269531 12.886719 L 32.292969 15.835938 L 31.578125 19.996094 L 35.316406 18.03125 L 39.050781 19.996094 L 38.335938 15.835938 L 41.359375 12.886719 L 37.183594 12.28125 Z M 35.316406 8.496094 "
          />
          <path
            fill="#3395fe"
            d="M 7.167969 37.859375 C 7.167969 37.3125 5.5625 36.867188 3.582031 36.867188 C 1.605469 36.867188 0 37.3125 0 37.859375 C 0 38.410156 1.605469 38.855469 3.582031 38.855469 C 5.5625 38.855469 7.167969 38.410156 7.167969 37.859375 Z M 7.167969 37.859375 "
          />
          <path
            fill="#3395fe"
            d="M 23.777344 37.859375 C 23.777344 37.007812 21.28125 36.3125 18.203125 36.3125 C 15.125 36.3125 12.628906 37.007812 12.628906 37.859375 C 12.628906 38.714844 15.125 39.410156 18.203125 39.410156 C 21.28125 39.410156 23.777344 38.714844 23.777344 37.859375 Z M 23.777344 37.859375 "
          />
          <path
            fill="#3395fe"
            d="M 36.835938 35.976562 L 35.316406 39.113281 L 33.792969 35.976562 C 30.6875 36.171875 28.367188 36.941406 28.367188 37.859375 C 28.367188 38.925781 31.476562 39.792969 35.316406 39.792969 C 39.152344 39.792969 42.265625 38.925781 42.265625 37.859375 C 42.265625 36.941406 39.941406 36.171875 36.835938 35.976562 Z M 36.835938 35.976562 "
          />
        </svg>
      )
    case 'MOVE_DEPARTMENT':
      return (
        <svg viewBox="0 0 45 45" width={width || 45} height={height || 45}>
          <path
            fill="#3395fe"
            d="M 22.5 8.617188 C 24.757812 8.617188 26.589844 6.785156 26.589844 4.527344 C 26.589844 2.265625 24.757812 0.433594 22.5 0.433594 C 20.242188 0.433594 18.410156 2.265625 18.410156 4.527344 C 18.410156 6.785156 20.242188 8.617188 22.5 8.617188 Z M 22.5 2.480469 C 23.628906 2.480469 24.546875 3.394531 24.546875 4.527344 C 24.546875 5.65625 23.628906 6.570312 22.5 6.570312 C 21.371094 6.570312 20.453125 5.65625 20.453125 4.527344 C 20.453125 3.394531 21.371094 2.480469 22.5 2.480469 Z M 22.5 2.480469 "
          />
          <path
            fill="#3395fe"
            d="M 23.984375 9.28125 C 23.96875 9.28125 23.949219 9.28125 23.933594 9.28125 L 21.066406 9.28125 C 17.992188 9.195312 15.425781 11.621094 15.34375 14.699219 C 15.339844 14.714844 15.339844 14.734375 15.339844 14.753906 L 15.339844 15.570312 C 15.339844 16.132812 15.902344 16.441406 16.464844 16.441406 L 28.535156 16.441406 C 29.097656 16.441406 29.660156 16.132812 29.660156 15.570312 L 29.660156 14.753906 C 29.605469 11.675781 27.0625 9.226562 23.984375 9.28125 Z M 17.488281 14.394531 C 17.589844 12.859375 19.175781 11.328125 21.066406 11.328125 L 23.933594 11.328125 C 25.824219 11.328125 27.410156 12.859375 27.511719 14.394531 Z M 17.488281 14.394531 "
          />
          <path
            fill="#3395fe"
            d="M 5.878906 26.410156 C 6.445312 26.410156 6.902344 25.953125 6.902344 25.390625 C 6.898438 20.65625 9.042969 16.179688 12.734375 13.21875 C 13.136719 12.824219 13.144531 12.175781 12.75 11.773438 C 12.410156 11.421875 11.863281 11.363281 11.453125 11.632812 C 7.277344 14.976562 4.851562 20.039062 4.859375 25.390625 C 4.859375 25.953125 5.316406 26.410156 5.878906 26.410156 Z M 5.878906 26.410156 "
          />
          <path
            fill="#3395fe"
            d="M 27.484375 40.160156 C 27.476562 40.160156 27.46875 40.164062 27.460938 40.167969 C 24.257812 41.238281 20.792969 41.238281 17.589844 40.167969 C 17.054688 40 16.484375 40.296875 16.3125 40.832031 C 16.117188 41.332031 16.367188 41.894531 16.867188 42.089844 C 16.886719 42.097656 16.90625 42.105469 16.925781 42.109375 C 20.558594 43.339844 24.492188 43.339844 28.125 42.109375 C 28.667969 41.917969 28.960938 41.332031 28.789062 40.78125 C 28.601562 40.25 28.015625 39.96875 27.484375 40.160156 Z M 27.484375 40.160156 "
          />
          <path
            fill="#3395fe"
            d="M 31.5 12.65625 C 35.640625 15.574219 38.105469 20.324219 38.097656 25.390625 C 38.097656 25.953125 38.554688 26.410156 39.121094 26.410156 C 39.683594 26.410156 40.140625 25.953125 40.140625 25.390625 C 40.128906 19.660156 37.347656 14.289062 32.675781 10.96875 C 32.210938 10.644531 31.570312 10.757812 31.246094 11.222656 C 30.917969 11.691406 31.035156 12.332031 31.5 12.65625 Z M 31.5 12.65625 "
          />
          <path
            fill="#3395fe"
            d="M 7.160156 36.742188 C 9.417969 36.742188 11.25 34.910156 11.25 32.652344 C 11.25 30.390625 9.417969 28.558594 7.160156 28.558594 C 4.898438 28.558594 3.066406 30.390625 3.066406 32.652344 C 3.066406 34.910156 4.898438 36.742188 7.160156 36.742188 Z M 7.160156 30.605469 C 8.289062 30.605469 9.203125 31.519531 9.203125 32.652344 C 9.203125 33.78125 8.289062 34.695312 7.160156 34.695312 C 6.03125 34.695312 5.113281 33.78125 5.113281 32.652344 C 5.113281 31.519531 6.03125 30.605469 7.160156 30.605469 Z M 7.160156 30.605469 "
          />
          <path
            fill="#3395fe"
            d="M 8.644531 37.40625 C 8.628906 37.40625 8.609375 37.40625 8.589844 37.40625 L 5.726562 37.40625 C 2.648438 37.320312 0.0859375 39.746094 0 42.824219 C 0 42.839844 0 42.859375 0 42.878906 L 0 43.695312 C 0 44.257812 0.5625 44.566406 1.125 44.566406 L 13.191406 44.566406 C 13.753906 44.566406 14.316406 44.257812 14.316406 43.695312 L 14.316406 42.878906 C 14.261719 39.800781 11.722656 37.351562 8.644531 37.40625 Z M 2.148438 42.519531 C 2.25 40.984375 3.835938 39.453125 5.726562 39.453125 L 8.589844 39.453125 C 10.484375 39.453125 12.066406 40.984375 12.171875 42.519531 Z M 2.148438 42.519531 "
          />
          <path
            fill="#3395fe"
            d="M 33.75 32.652344 C 33.75 34.910156 35.582031 36.742188 37.839844 36.742188 C 40.101562 36.742188 41.933594 34.910156 41.933594 32.652344 C 41.933594 30.390625 40.101562 28.558594 37.839844 28.558594 C 35.582031 28.558594 33.75 30.390625 33.75 32.652344 Z M 39.886719 32.652344 C 39.886719 33.78125 38.96875 34.695312 37.839844 34.695312 C 36.710938 34.695312 35.796875 33.78125 35.796875 32.652344 C 35.796875 31.519531 36.710938 30.605469 37.839844 30.605469 C 38.96875 30.605469 39.886719 31.519531 39.886719 32.652344 Z M 39.886719 32.652344 "
          />
          <path
            fill="#3395fe"
            d="M 39.328125 37.40625 C 39.308594 37.40625 39.289062 37.40625 39.273438 37.40625 L 36.410156 37.40625 C 33.332031 37.320312 30.769531 39.746094 30.683594 42.824219 C 30.683594 42.839844 30.683594 42.859375 30.683594 42.878906 L 30.683594 43.695312 C 30.683594 44.257812 31.246094 44.566406 31.808594 44.566406 L 43.875 44.566406 C 44.4375 44.566406 45 44.257812 45 43.695312 L 45 42.878906 C 44.945312 39.800781 42.40625 37.351562 39.328125 37.40625 Z M 32.828125 42.519531 C 32.933594 40.984375 34.515625 39.453125 36.410156 39.453125 L 39.273438 39.453125 C 41.164062 39.453125 42.75 40.984375 42.851562 42.519531 Z M 32.828125 42.519531 "
          />
        </svg>
      )
    case 'ADD_ITEM':
      return (
        <svg viewBox="0 0 20 20" width={width || 20} height={height || 20}>
          <path
            fill="#3395fe"
            d="M 18.839844 8.839844 L 11.160156 8.839844 L 11.160156 1.160156 C 11.160156 0.519531 10.640625 0 10 0 C 9.359375 0 8.839844 0.519531 8.839844 1.160156 L 8.839844 8.839844 L 1.160156 8.839844 C 0.519531 8.839844 0 9.359375 0 10 C 0 10.640625 0.519531 11.160156 1.160156 11.160156 L 8.839844 11.160156 L 8.839844 18.839844 C 8.839844 19.480469 9.359375 20 10 20 C 10.640625 20 11.160156 19.480469 11.160156 18.839844 L 11.160156 11.160156 L 18.839844 11.160156 C 19.480469 11.160156 20 10.640625 20 10 C 20 9.359375 19.480469 8.839844 18.839844 8.839844 Z M 18.839844 8.839844 "
          />
        </svg>
      )
    case 'PHONE_HOME':
      return (
        <svg viewBox="0 0 26 26" width={width || 26} height={height || 26}>
          <path
            fill="#FFF"
            d="M.898 14.292h2.118v8.768c0 .517.408.94.908.94h6.202c.499 0 .907-.423.907-.94v-6.42h3.782v6.42c0 .517.408.94.908.94h5.9c.498 0 .907-.423.907-.94v-8.768H25.1a.908.908 0 0 0 .832-.58.968.968 0 0 0-.196-1.017L13.907.278a.882.882 0 0 0-1.27-.015L.277 12.679a.963.963 0 0 0-.21 1.034c.135.36.468.579.831.579zM13.242 2.267l9.681 10.146h-1.3c-.5 0-.909.423-.909.94v8.768H16.63v-6.42c0-.517-.408-.94-.907-.94h-5.597c-.5 0-.908.423-.908.94v6.42H4.831v-8.768c0-.517-.408-.94-.907-.94h-.787L13.242 2.267z"
          />
        </svg>
      )
    case 'PROFILE':
      return (
        <svg viewBox="0 0 26 26" width={width || 26} height={height || 26}>
          <path
            fill="#FFF"
            d="M 12.957031 14.515625 C 16.800781 14.515625 19.917969 11.398438 19.917969 7.558594 C 19.917969 3.714844 16.800781 0.617188 12.957031 0.617188 C 9.113281 0.617188 6 3.734375 6 7.558594 C 6 11.378906 9.113281 14.515625 12.957031 14.515625 Z M 12.957031 2.433594 C 15.773438 2.433594 18.082031 4.738281 18.082031 7.558594 C 18.082031 10.375 15.773438 12.679688 12.957031 12.679688 C 10.140625 12.679688 7.835938 10.375 7.835938 7.554688 C 7.835938 4.738281 10.140625 2.433594 12.957031 2.433594 Z M 12.957031 2.433594 "
          />
          <path
            fill="#FFF"
            d="M 0.917969 25.382812 L 25.082031 25.382812 C 25.59375 25.382812 26 24.976562 26 24.464844 C 26 19.660156 22.09375 15.730469 17.269531 15.730469 L 8.730469 15.730469 C 3.929688 15.730469 0 19.640625 0 24.464844 C 0 24.976562 0.40625 25.382812 0.917969 25.382812 Z M 8.730469 17.566406 L 17.269531 17.566406 C 20.769531 17.566406 23.652344 20.171875 24.101562 23.546875 L 1.898438 23.546875 C 2.347656 20.195312 5.230469 17.566406 8.730469 17.566406 Z M 8.730469 17.566406 "
          />
        </svg>
      )
    case 'LOG_OUT':
      return (
        <svg viewBox="0 0 26 26" width={width || 26} height={height || 26}>
          <path
            fill="#FFF"
            d="M 18.292969 6.152344 C 18.855469 6.152344 19.308594 5.699219 19.308594 5.136719 L 19.308594 2.507812 C 19.308594 1.125 18.171875 0 16.773438 0 L 4.617188 0 C 3.21875 0 2.082031 1.125 2.082031 2.507812 L 2.082031 23.492188 C 2.082031 24.875 3.21875 26 4.617188 26 L 16.773438 26 C 18.171875 26 19.308594 24.875 19.308594 23.492188 L 19.308594 20.863281 C 19.308594 20.300781 18.855469 19.847656 18.292969 19.847656 C 17.730469 19.847656 17.277344 20.300781 17.277344 20.863281 L 17.277344 23.492188 C 17.277344 23.753906 17.050781 23.96875 16.773438 23.96875 L 4.617188 23.96875 C 4.339844 23.96875 4.113281 23.753906 4.113281 23.492188 L 4.113281 2.507812 C 4.113281 2.246094 4.339844 2.03125 4.617188 2.03125 L 16.773438 2.03125 C 17.050781 2.03125 17.277344 2.246094 17.277344 2.507812 L 17.277344 5.136719 C 17.277344 5.699219 17.730469 6.152344 18.292969 6.152344 Z M 18.292969 6.152344 "
          />
          <path
            fill="#FFF"
            d="M 23.613281 12.273438 L 18.207031 7 C 17.804688 6.609375 17.160156 6.617188 16.769531 7.019531 C 16.378906 7.421875 16.386719 8.0625 16.789062 8.457031 L 20.40625 11.984375 L 10.695312 11.984375 C 10.132812 11.984375 9.679688 12.4375 9.679688 13 C 9.679688 13.5625 10.132812 14.015625 10.695312 14.015625 L 20.40625 14.015625 L 16.789062 17.542969 C 16.386719 17.9375 16.378906 18.578125 16.769531 18.980469 C 17.160156 19.382812 17.804688 19.390625 18.207031 19 L 23.613281 13.726562 C 24.023438 13.328125 24.019531 12.667969 23.613281 12.273438 Z M 23.613281 12.273438 "
          />
        </svg>
      )
    case 'TIMER':
      return (
        <svg
          enableBackground="new 0 0 512 512"
          viewBox="0 0 512 512"
          width={32}
          height={32}
        >
          <g fill="#3395fe">
            <path d="m391.84 48.87l54.306 45.287c3.739 3.119 8.281 4.641 12.798 4.641 5.729 0 11.415-2.448 15.371-7.191 7.074-8.483 5.932-21.095-2.552-28.169l-54.306-45.288c-8.481-7.074-21.094-5.933-28.169 2.551-7.074 8.483-5.932 21.094 2.552 28.169z" />
            <path d="m53.057 98.797c4.516 0 9.059-1.522 12.798-4.641l54.305-45.286c8.483-7.074 9.626-19.686 2.552-28.169-7.073-8.482-19.686-9.625-28.169-2.551l-54.306 45.287c-8.483 7.074-9.626 19.686-2.552 28.169 3.957 4.743 9.643 7.191 15.372 7.191z" />
            <path d="m422.88 109.12c-39.826-39.826-91.383-63.649-146.88-68.276v-20.847c0-11.046-8.954-20-20-20s-20 8.954-20 20v20.847c-55.494 4.627-107.05 28.449-146.88 68.275-44.575 44.575-69.123 103.84-69.123 166.88s24.548 122.3 69.123 166.88c44.574 44.575 103.84 69.123 166.88 69.123 50.754 0 99.118-15.869 139.86-45.894 8.893-6.552 10.789-19.072 4.237-27.965-6.553-8.894-19.074-10.789-27.966-4.237-33.822 24.923-73.981 38.096-116.14 38.096-108.08 0-196-87.925-196-196s87.925-196 196-196 196 87.925 196 196c0 33.01-8.354 65.638-24.161 94.356-5.326 9.677-1.799 21.839 7.878 27.165 9.674 5.324 21.838 1.8 27.165-7.878 19.049-34.611 29.118-73.908 29.118-113.64 0-63.038-24.548-122.3-69.123-166.88z" />
            <path d="m353.43 155.6c-8.584-6.947-21.178-5.622-28.128 2.965l-63.061 77.925c-2.036-0.321-4.121-0.491-6.245-0.491-22.056 0-40 17.944-40 40s17.944 40 40 40 40-17.944 40-40c0-5.052-0.951-9.884-2.668-14.338l63.067-77.933c6.949-8.587 5.622-21.181-2.965-28.128z" />
          </g>
        </svg>
      )
    case 'LEGEND':
      return (
        <svg
          width={width || 24}
          height={height || 24}
          viewBox="0 0 472.784 472.784"
          enableBackground="new 0 0 472.784 472.784"
          transform="rotate(0)"
        >
          <g fill="#006ee5">
            <rect
              className=""
              y="116.39"
              width="302"
              height="40"
              data-old_color="#3395fe"
              data-original="#005ECE"
            />
            <polygon
              className=""
              points="398.25 203.27 398.25 277.8 472.78 203.27"
              data-old_color="#3395fe"
              data-original="#005ECE"
            />
            <polygon
              className="active-path"
              points="323.72 203.27 398.25 277.8 398.25 203.27"
              data-old_color="#3395fe"
              data-original="#2488FF"
            />
            <rect
              className=""
              y="316.39"
              width="302"
              height="40"
              data-old_color="#3395fe"
              data-original="#005ECE"
            />
            <rect
              className=""
              y="216.39"
              width="302"
              height="40"
              data-old_color="#3395fe"
              data-original="#005ECE"
            />
          </g>
        </svg>
      )

    case 'SETTINGS':
      return (
        <svg
          fill="#fff"
          width={width || 24}
          height={height || 24}
          viewBox="0 0 512 512"
        >
          <path d="M485.793 202.254l-35.937-6.096c-3.744-12.086-8.557-23.744-14.44-34.868l21.177-29.627c8.984-12.62 7.594-29.84-3.423-40.75L421.298 59.04c-6-6-13.904-9.306-22.353-9.306a31.13 31.13 0 0 0-18.3 5.883l-29.733 21.177c-11.552-6.096-23.638-11.123-36.15-14.867l-6-35.5C306.214 11.124 293.06.001 277.55.001h-45.028c-15.5 0-28.664 11.123-31.23 26.418l-6.204 36.365c-11.98 3.743-23.637 8.663-34.76 14.653L130.914 56.26c-5.348-3.85-11.765-5.883-18.397-5.883-8.45 0-16.47 3.316-22.353 9.305l-31.98 31.873c-10.9 10.9-12.407 28.13-3.423 40.75l21.4 30.055c-5.882 11.23-10.588 22.888-14.225 34.974l-35.5 6C11.123 205.9 0 219.046 0 234.555v45.028c0 15.5 11.123 28.664 26.418 31.23l36.365 6.204c3.743 11.98 8.663 23.637 14.653 34.76l-21.07 29.306c-8.985 12.62-7.594 29.84 3.422 40.75l31.873 31.873c6 6 13.904 9.305 22.354 9.305 6.63 0 12.94-2.032 18.3-5.882l30.055-21.392c10.802 5.67 22.14 10.268 33.798 13.905l6 35.937c2.567 15.294 15.723 26.418 31.23 26.418h45.136c15.508 0 28.664-11.124 31.23-26.418l6.096-35.937c12.086-3.744 23.744-8.557 34.868-14.44l29.626 21.177c5.348 3.85 11.765 5.882 18.397 5.882 8.45 0 16.364-3.315 22.353-9.305l31.873-31.872c10.9-10.9 12.407-28.13 3.423-40.75L435.203 350.6c5.882-11.23 10.802-22.9 14.44-34.868l35.937-6c15.294-2.567 26.418-15.723 26.418-31.23v-45.03c.214-15.508-10.9-28.664-26.204-31.23zm-2.46 76.26c0 1.4-.963 2.567-2.353 2.78l-44.922 7.487c-5.668.963-10.16 5.134-11.55 10.6-4.064 15.722-10.268 30.803-18.6 44.814-2.888 4.92-2.674 11.017.642 15.723l26.418 37.22a2.92 2.92 0 0 1-.321 3.637l-31.873 31.873c-.75.748-1.497.855-2.032.855-.642 0-1.177-.213-1.605-.534l-37.113-26.418c-4.6-3.316-10.803-3.53-15.723-.642-14 8.342-29.092 14.546-44.814 18.6-5.562 1.4-9.733 6-10.6 11.55l-7.594 44.922c-.214 1.4-1.4 2.353-2.78 2.353h-45.03c-1.4 0-2.567-.963-2.78-2.353l-7.487-44.922c-.962-5.668-5.133-10.16-10.588-11.55-15.295-3.957-30.055-10.054-43.852-17.968a14.8 14.8 0 0 0-7.273-1.926c-2.888 0-5.882.856-8.342 2.674l-37.435 26.632c-.535.32-1.07.535-1.604.535-.428 0-1.284-.107-2.032-.856l-31.873-31.872c-.963-.963-1.07-2.46-.32-3.637l26.3-36.9c3.316-4.706 3.53-10.9.642-15.83-8.343-13.904-14.76-28.985-18.824-44.708-1.498-5.454-6-9.626-11.552-10.588l-45.242-7.7c-1.4-.214-2.353-1.4-2.353-2.78v-45.028c0-1.4.963-2.567 2.353-2.78l44.6-7.487c5.668-.962 10.267-5.134 11.658-10.695 3.957-15.723 10.054-30.9 18.3-44.922 2.888-4.92 2.567-11.016-.75-15.615L78.4 115.62c-.75-1.07-.642-2.674.32-3.636l31.873-31.873c.75-.75 1.498-.856 2.032-.856a2.63 2.63 0 0 1 1.605.535l36.9 26.3c4.706 3.316 10.9 3.53 15.83.642 13.904-8.343 28.985-14.76 44.707-18.824 5.455-1.498 9.626-6 10.6-11.552l7.7-45.242c.214-1.4 1.4-2.353 2.78-2.353h45.028c1.4 0 2.567.963 2.78 2.353l7.487 44.6c.962 5.668 5.133 10.267 10.695 11.658 16.15 4.064 31.552 10.375 45.884 18.824 4.92 2.888 11.017 2.674 15.723-.642l36.9-26.525c.535-.32 1.07-.534 1.605-.534.428 0 1.283.106 2.032.855l31.873 31.873c.962.963 1.07 2.46.32 3.636l-26.42 37.114c-3.315 4.6-3.53 10.803-.64 15.723 8.342 14 14.546 29.092 18.6 44.814 1.4 5.562 6 9.733 11.55 10.6l44.922 7.593c1.4.214 2.353 1.4 2.353 2.78v45.03h-.107zM256.052 145.46c-60.965 0-110.485 49.52-110.485 110.485s49.52 110.485 110.485 110.485 110.485-49.52 110.485-110.485-49.52-110.485-110.485-110.485zm0 192.092c-45.028 0-81.607-36.58-81.607-81.607s36.58-81.607 81.607-81.607 81.607 36.58 81.607 81.607-36.58 81.607-81.607 81.607z" />
        </svg>
      )

    case 'SERVICE_REQUESTS':
      return (
        <svg
          fill="none"
          width={width || 28}
          height={height || 28}
          viewBox="0 0 28 28"
        >
          <path
            d="M18.6569 21.5163C17.3819 22.97 15.7217 23.7706 13.9819 23.7706C10.2022 23.7706 7.12718 20.0151 7.12718 15.3991C7.12718 10.7831 10.202 7.02762 13.9817 7.02762C17.6945 7.02762 20.7037 10.5753 20.8324 15.1039C20.8435 15.4986 21.183 15.8061 21.5721 15.7981C21.9696 15.7869 22.2826 15.4581 22.2713 15.0636C22.1203 9.75584 18.4792 5.59827 13.9815 5.59827C9.40799 5.59827 5.68726 9.99495 5.68726 15.3991C5.68726 20.8033 9.4082 25.2 13.9815 25.2C16.1439 25.2 18.1896 24.2252 19.7421 22.4552C20.003 22.1575 19.9718 21.706 19.6719 21.4469C19.3723 21.1876 18.9176 21.2186 18.6569 21.5163Z"
            fill={color || '#ffffff'}
          />
          <path
            d="M28 13.7318C28 11.6143 26.4272 9.8785 24.4222 9.69596C22.4854 5.1933 18.534 2.09998 13.9814 2.09998C9.428 2.09998 5.47612 5.19432 3.53956 9.698C1.55282 9.89892 0 11.6278 0 13.7318C0 15.6561 1.29865 17.2672 3.04046 17.6821C3.04457 17.6832 3.04725 17.6824 3.05115 17.6832C3.10154 17.6942 3.15336 17.7011 3.20724 17.7011C3.60475 17.7011 3.927 17.3812 3.927 16.9865V13.4182C4.90011 7.77858 9.0381 3.52933 13.9814 3.52933C18.9942 3.52933 23.1772 7.89987 24.0732 13.6581V16.4797C23.0641 16.9228 21.7897 17.4571 20.7481 17.8132C19.5961 18.2071 17.8148 18.6184 16.4699 18.9042C16.1246 18.465 15.3668 18.1593 14.4852 18.1593C13.2785 18.1593 12.3002 18.7307 12.3002 19.4356C12.3002 20.1404 13.2785 20.7118 14.4852 20.7118C14.8609 20.7118 15.2144 20.6562 15.5231 20.5588C16.7695 20.3126 19.5521 19.7337 21.2168 19.1648C22.3787 18.7676 23.7795 18.1755 24.8364 17.7083C25.4078 17.5921 25.9324 17.3456 26.3857 17.0036C26.404 16.995 26.4182 16.9883 26.4239 16.9854L26.4198 16.9771C27.3773 16.2377 28 15.0613 28 13.7318Z"
            fill={color || '#ffffff'}
          />
        </svg>
      )

    case 'DISCLOSE_ARROW':
      return (
        <svg width="16" height="23" viewBox="0 0 16 23" fill="none">
          <path d="M1 22L14 10.5455L1 1" stroke="#3395FE" strokeWidth="2" />
        </svg>
      )
    case 'WORKSPACE_RESERVATION':
      return (
        <svg
          fill="none"
          width={width || 28}
          height={height || 28}
          viewBox="0 0 28 28"
        >
          <path
            d="M19.2129 4.54687C18.5553 4.10937 16.4625 3.81824 14.0394 3.81824C11.5763 3.81824 9.52342 4.10937 8.82581 4.54687C8.12821 4.88733 7.63647 5.66369 7.63647 6.58642V7.41369C7.63647 8.33642 8.12821 9.11437 8.78582 9.45324C9.44196 9.89074 11.5348 10.1819 13.9994 10.1819C16.5854 10.1819 18.7212 9.84142 19.2959 9.35619C19.912 9.01574 20.3637 8.23937 20.3637 7.36437V6.58642C20.3623 5.66369 19.9105 4.88733 19.2129 4.54687Z"
            fill="white"
          />
          <path
            d="M19.7457 20.7887L19.7484 20.7872L19.7335 20.7828C19.6647 20.7501 19.5945 20.7249 19.5203 20.7071L13.9981 19.0128V16.9697C16.2045 16.9311 18.9036 16.8123 19.5028 16.6549C19.9508 16.5762 20.2882 16.1441 20.2882 15.6734V15.516C20.2882 14.9666 19.8766 14.5345 19.3907 14.4945C18.716 14.6518 15.9792 14.7305 13.9981 14.7692V14H12.6486V14.7692C10.7026 14.7305 9.55279 14.6132 8.91716 14.4945C8.39355 14.4945 7.9833 14.9652 7.9833 15.516V15.6734C7.9833 16.1842 8.35847 16.6163 8.8065 16.6549C9.40434 16.8123 10.5555 16.9311 12.6499 16.9697V19.0128L8.37331 20.7338C8.37196 20.7338 8.37601 20.7368 8.37871 20.7382C7.94956 20.8808 7.63647 21.298 7.63647 21.7955C7.63647 22.4102 8.1115 22.9091 8.69719 22.9091C9.28288 22.9091 9.75791 22.4102 9.75791 21.7955C9.75791 21.6885 9.73902 21.5861 9.71203 21.4866C9.71473 21.4866 9.71878 21.4896 9.71743 21.4881C10.353 21.2921 11.8078 20.912 12.519 20.912C12.8321 20.912 12.5163 20.9803 12.6526 21.053C12.4839 21.2505 12.3773 21.5089 12.3773 21.7955C12.3773 22.4102 12.8523 22.9091 13.438 22.9091C14.0237 22.9091 14.4988 22.4102 14.4988 21.7955C14.4988 21.5133 14.3948 21.2579 14.2302 21.0619C14.3813 20.9862 15.2599 20.912 15.5487 20.912C16.2194 20.912 17.631 21.2624 18.3084 21.4198C18.268 21.5371 18.2423 21.6618 18.2423 21.794C18.2423 22.4087 18.7173 22.9076 19.303 22.9076C19.8887 22.9076 20.3637 22.4087 20.3637 21.794C20.3597 21.35 20.1073 20.9669 19.7457 20.7887Z"
            fill="white"
          />
          <path
            d="M25.6999 11.4546H2.29869C1.04995 11.4546 0 12.1719 0 13.5121V22.1302C0 22.5684 0.505375 22.9091 0.942153 22.9091C1.37893 22.9091 1.88431 22.5684 1.88431 22.1302V13.724C1.88291 13.3102 2.30288 12.8864 2.71166 12.8864H25.2883C25.6957 12.8864 26.1171 13.3102 26.1171 13.724V22.1302C26.1171 22.5698 26.6225 22.9091 27.0592 22.9091C27.4932 22.9091 28 22.5684 28 22.1302V13.5121C27.9972 12.1719 26.9473 11.4546 25.6999 11.4546Z"
            fill="white"
          />
        </svg>
      )
    case 'MEETING_RESERVATION':
      return (
        <svg
          fill="none"
          width={width || 28}
          height={height || 28}
          viewBox="0 0 28 28"
        >
          <rect x="2.5" y="4.5" width="23" height="22" stroke="#fff" />
          <rect x="10" y="11" width="3" height="3" fill="#fff" />
          <rect x="10" y="16" width="3" height="3" fill="#fff" />
          <rect x="10" y="21" width="3" height="3" fill="#fff" />
          <rect x="5" y="16" width="3" height="3" fill="#fff" />
          <rect x="5" y="21" width="3" height="3" fill="#fff" />
          <rect x="15" y="16" width="3" height="3" fill="#fff" />
          <rect x="20" y="16" width="3" height="3" fill="#fff" />
          <rect x="15" y="21" width="3" height="3" fill="#fff" />
          <rect x="15" y="11" width="3" height="3" fill="#fff" />
          <rect x="20" y="11" width="3" height="3" fill="#fff" />
          <mask id="path-12-inside-1" fill="#fff">
            <rect x="18" y="1" width="5" height="6" rx="1" />
          </mask>
          <rect
            x="18"
            y="1"
            width="5"
            height="6"
            rx="1"
            stroke="#fff"
            strokeWidth="3"
            mask="url(#path-12-inside-1)"
          />
          <mask id="path-13-inside-2" fill="#fff">
            <rect x="5" y="1" width="5" height="6" rx="1" />
          </mask>
          <rect
            x="5"
            y="1"
            width="5"
            height="6"
            rx="1"
            stroke="#fff"
            strokeWidth="3"
            strokeLinejoin="round"
            mask="url(#path-13-inside-2)"
          />
          <rect x="2" y="4" width="24" height="5" fill="#fff" />
        </svg>
      )
    case 'USER_MENU_ARROW':
      return (
        <svg
          fill="none"
          width={width || 8}
          height={height || 5}
          viewBox="0 0 8 5"
        >
          <path d="M4 5L0.535898 0.333333L7.4641 0.333333L4 5Z" fill="#fff" />
        </svg>
      )
    case 'LOCATE_ROOM':
      return (
        <svg
          viewBox="0 0 12 15"
          fill="none"
          width={width || 12}
          height={height || 15}
        >
          <path
            d="M11.5 6.1106C11.5 7.61787 10.6716 9.08931 9.48401 10.49C8.52664 11.6192 7.38783 12.6449 6.36638 13.565C6.24235 13.6767 6.12004 13.7868 6 13.8954C5.87996 13.7868 5.75765 13.6767 5.63362 13.565C4.61217 12.6449 3.47336 11.6192 2.51599 10.49C1.32841 9.08931 0.5 7.61787 0.5 6.1106C0.5 3.0033 2.971 0.5 6 0.5C9.029 0.5 11.5 3.0033 11.5 6.1106Z"
            fill="#006ee5"
            stroke="#006ee5"
          />
          <circle cx="6.03" cy="6.029" r="3.75" fill="#fff" />
        </svg>
      )
    case 'CLEAR':
      return (
        <svg
          viewBox="0 0 9 10"
          fill="none"
          width={width || 12}
          height={height || 12}
          onClick={onClick}
        >
          <path
            stroke={color || '#000'}
            strokeLinecap="round"
            d="M1.207 1.7L8.278 8.771"
          />
          <path
            stroke={color || '#000'}
            strokeLinecap="round"
            d="M1.2 8.793L8.271 1.722"
          />
        </svg>
      )
  }
}

Icons.propTypes = {
  icon: PropTypes.string.isRequired
}

export default Icons
